<template>
  <div id="covid-map-africa">
    <div class="site-toggles">
      <v-sheet class="toolbar py-1 px-3" dense color="#607d8b6b" dark prominent width="100%">
        <v-row no-gutters>
          <v-col class="d-flex align-center" :cols="12" md="auto">
            <v-autocomplete dense
              v-model="search"
              :loading="loading"
              :disabled="loading"
              :items="allLocations"
              :no-data-text="loading ? 'Loading...' : 'No data available'"
              flat
              solo
              light
              hide-details
              prepend-inner-icon="search"
              item-text="value"
              :item-value="v => v"
              label="Search for country, province, city or town..."
              class="search"
              full-width
              :menu-props="{ openOnClick: false }"
            >
              <template v-slot:selection="data">
                {{data.item.value}}
              </template>
              <template v-slot:item="data">
                <template v-if="data.item && data.item.substring">
                  <v-list-item-content v-text="data.item"></v-list-item-content>
                </template>
                <template v-else>
                  <v-list-item-content>
                    <v-list-item-title v-html="data.item.value"></v-list-item-title>
                    <v-list-item-subtitle v-html="data.item.levelName"></v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </template>

            </v-autocomplete>
          </v-col>
          <v-spacer></v-spacer>
          <v-col class="d-flex align-center justify-center py-1" :cols="12" sm="auto">
            <v-btn-toggle class="mode-toggle" :class="$vuetify.breakpoint.xsOnly ? 'mt-1' : 'mr-3'" v-model="mode" mandatory :multiple="false" 
              dark dense background-color="">
              <v-btn value="active" color="blue darken-1" :small="$vuetify.breakpoint.xsOnly">
                Active
              </v-btn>
              <v-btn value="total" color="blue darken-1" :small="$vuetify.breakpoint.xsOnly">
                Total
              </v-btn>
              <v-btn value="trend" color="blue darken-1" :small="$vuetify.breakpoint.xsOnly">
                Trend
              </v-btn>
              <v-btn value="deaths" color="blue darken-1" :small="$vuetify.breakpoint.xsOnly">
                Deaths
              </v-btn>
            </v-btn-toggle>
          </v-col>
          <v-col :cols="12" sm="auto" class="d-flex align-center py-1 justify-center">
            <v-btn-toggle class="mr-3" v-model="level" mandatory :multiple="false" 
              dark dense background-color="">
              <v-btn value="state" color="blue darken-1" :small="$vuetify.breakpoint.xsOnly">
                Country
              </v-btn>
              <v-btn value="county" color="blue darken-1" :small="$vuetify.breakpoint.xsOnly">
                Province
              </v-btn>
            </v-btn-toggle>
            
            <v-btn-toggle v-model="relativeToState" :multiple="false"
              dark dense background-color="">
              <v-btn :value="true" :color="level == 'state' ? 'blue-grey darken-1' : 'blue darken-1'" :small="$vuetify.breakpoint.xsOnly">
                Relative to Country
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>

      </v-sheet>
      <!-- <a href="javascript:fullReset()" id="resetBtn" class="reset-btn">Start Over</a> -->
      <!-- <span class="spacer"></span>
      <input type="text" placeholder="Search state, county or town..." />
      <a
        href="javascript:toggleTestSites()"
        id="toggleTestSites"
        class="toggle on"
        >Search</a
      >
      <a
        href="javascript:toggleTestSites()"
        id="toggleTestSites"
        class="toggle on"
        >State</a
      >
      <a
        href="javascript:this.()"
        id="toggleClinicalTrials"
        class="toggle on"
        >Active Cases</a
      > -->
    </div>

    <!-- <div class="container">
      <a href="#" class="arrow up">Up</a>
    </div> -->

    <div class="map-frame-wrapper">
      <div class="map-frame">
        <div class="map-bottom">

          <a @click="reset()" id="zoomOutBtn" class="zoom-out-btn">
            <i class="material-icons">zoom_out</i>
          </a>
          <span class="hint" v-if="showHint">
            Click on Countries for reopenings, test sites and travel info.
          </span>
          <!-- <span class="hint info-source" v-if="!showHint">
            {{ "Info from >25,000 sources (incl NYT cases & government)" }}
            <span v-if="latestDate">as of Oct 30, 2020.</span>
          </span> -->
        </div>
      </div>
      <div class="loading-map">
        <div class="flashing">

          <h1>Loading...</h1>
          Crunching info from every province and country. Please wait while the map loads.
        </div>

        
        <section class="main-instructions">
          <br /><br /><br />

          CLICK COUNTRIES & PROVINCES TO EXPLORE<br />
          SEE UPDATES ON CASES & GOVERNMENT DECISIONS<br />
          FIND THE CLOSEST TESTING SITES & CLINICAL RESEARCH SITES<br />
          SIGN UP FOR NOTIFICATIONS FOR CHANGES IN YOUR AREA<br />
          TAP ON BLUE TEXT & BOXES FOR MORE INFORMATION <br />
        </section>
      </div>
    </div>
    <div class="controls">
      <a class="play-btn" @click="animatemap()">
        <i class="material-icons">play_arrow</i>
      </a>
      <span class="ranges">
        <input
          type="range"
          min="21"
          max="365"
          value="19"
          step="1"
          class="slider"
          id="myRange-top"
          @change="setToDay($event.target.value)"
        />
        <input
          type="range"
          min="21"
          max="365"
          value="19"
          step="1"
          class="slider"
          id="myRange"
        />
      </span>
      <span id="date"></span>
    </div>
    <!-- <div class="last-updated">
      <div>
        Info based on latest NYT updates
        <span class="fieldHideable" style="display: none">and government updates as of
          <span id="field-updatedDate"></span>
        </span>
      </div>
    </div> -->
    <div class="bc-wrapper">
      <a @click="fullReset()" id="resetBtn" class="reset-btn"
        >Start Over</a
      >
      <ul class="bc">
        <li id="bc-map" style="display: none">
          <a @click="reset()">
            <i class="material-icons">zoom_out_map</i>
            <pre>&nbsp;&nbsp;</pre>
          </a>
        </li>
        <li id="bc-state" style="display: none">
          <a href="#">Country</a>
        </li>
        <li id="bc-county" style="display: none">
          <a href="#">State</a>
        </li>
        <li style="display: none"><a href="#"></a></li>
      </ul>
    </div>

    <div class="profiles">
      <!-- <div class="combos">
        <select
          class="custom-select my-1"
          id="stateCombo"
          onchange="stateComboChanged()"
        >
          <option selected value="0">Choose State...</option>
        </select>
        <select
          class="custom-select my-1"
          id="countyCombo"
          onchange="countyComboChanged()"
        >
          <option selected value="0">Choose County...</option>
        </select>
      </div> -->
      <v-expansion-panels v-model="profilePanel" accordion class="accordion" id="profilesAccordion">
        <v-expansion-panel class="card state-profile" v-show="profile.showState">
          <v-expansion-panel-header class="card-header pa-1">
            <h2
              class="mb-0"
              data-toggle="collapse"
              data-target="#collapseState"
              aria-expanded="true"
              aria-controls="collapseState"
            >
              <span class="name">State</span>
            </h2>
          </v-expansion-panel-header>
          <v-expansion-panel-content id="collapseState">

            <div class="card-body">
              <label class="ma-0">
                <i class="cases-icon"></i>
                <span class="cases"></span>
              </label>

              <div id="stateCasesChartWrapper">
                <div id="stateCasesChart"></div>
              </div>

              <h5 class="mt-4 banner">Country Mandate Status</h5>

              <div class="summary">
                <span id="field-executiveSummary"></span>
              </div>
              <div class="group">
                <h5>Reopening Status</h5>
                <div id="reopeningStatusChartWrapper">
                  <div id="reopeningStatusChart"></div>
                </div>
              </div>
              <div class="group fieldHideable">
                <div class="source">
                  For more information:
                  <a href="link" class="link-travelLink" id="field-travelSource"
                    >Source</a
                  >
                </div>
                <h5>Travel</h5>
                <div class="groupChart"></div>

                <div class="main">
                  <div>
                    <label>Initial Shut Down: </label>
                    <span id="field-travelShutdown"></span>
                  </div>
                  <div>
                    <label>International Flights: </label>
                    <span id="field-travelInternationalFlights"></span>
                  </div>
                  <div>
                    <label>Domestic Flights: </label>
                    <span id="field-travelDomesticFlights"></span>
                  </div>
                  <div>
                    <label>Land Border Crossing: </label>
                    <span id="field-travelLandBorderCrossing"></span>
                  </div>
                  <div>
                    <label>Intra-country travel (Citizens): </label>
                    <span id="field-travelIntraCountryTravel"></span>
                  </div>
                  <div>
                    <label>Tourism: </label>
                    <span id="field-travelTourism"></span>
                  </div>

                  <div>
                    <label>Negative COVID 19 Test (Tourism): </label>
                    <span id="field-travelNegativeCovidTest"></span>
                  </div>
                  <div>
                    <label>Quarantine: </label>
                    <span id="field-travelQuarantine"></span>
                  </div>
                </div>
                <div class="box fieldHideable">
                  <div>
                    <label>If Sick: </label>
                    <span id="field-travelIfSick"></span>
                  </div>
                  <div>
                    <label>Vulnerable: </label>
                    <span id="field-travelVulnerable"></span>
                  </div>
                </div>
              </div>
              <div class="group fieldHideable">
                <div class="source">
                  For more information:
                  <a href="link" class="link-peopleLink" id="field-peopleSource"
                    >Source</a
                  >
                </div>
                <h5>People</h5>
                <div class="groupChart"></div>
                <div class="main">
                  <div>
                    <label>Stay Home: </label>
                    <span id="field-peopleStayAtHome">Required</span>
                  </div>
                  <div>
                    <label>Face Covering: </label>
                    <span id="field-peopleMasks">Required</span>
                  </div>
                  <div>
                    <label>Curfew: </label>
                    <span id="field-peopleCurfew"></span>
                  </div>
                </div>
                <div class="box fieldHideable">
                  <div>
                    <label>If Sick: </label>
                    <span id="field-peopleIfSick">Required</span>
                  </div>
                  <div>
                    <label>Vulnerable: </label>
                    <span id="field-peopleVulnerable"></span>
                  </div>
                </div>
              </div>
              <div class="group fieldHideable">
                <div class="source">
                  For more information:
                  <a
                    href="link"
                    class="link-gatheringLink"
                    id="field-gatheringSource"
                    >Source</a
                  >
                </div>
                <h5>
                  Social Gatherings<span id="special-gatheringOpen"
                    >: Not Permitted</span
                  >
                </h5>
                <div class="groupChart"></div>
                <div class="main fieldHideable">
                  <div>
                    <label>Face Covering: </label>
                    <span id="field-gatheringMasks"></span>
                  </div>
                </div>
                <div class="box fieldHideable icon-box">
                  <div class="icon" title="Party Size">
                    <i class="material-icons">people_alt</i>
                    <span id="field-gatheringPartySize">6 ft</span>
                  </div>
                  <div class="icon" title="Social Distancing">
                    <i class="material-icons">sync_alt</i>
                    <span id="field-gatheringSocialDistancing">50 or less</span>
                  </div>
                </div>
              </div>
              <div class="group fieldHideable">
                <div class="source">
                  For more information:
                  <a
                    href="link"
                    class="link-worshipLink"
                    id="field-worshipSource"
                    >Source</a
                  >
                </div>
                <h5>
                  Worship
                </h5>
                <div class="groupChart"></div>
                <div class="main fieldHideable">
                  <div>
                    <label>Face Covering: </label>
                    <span id="field-worshipMasks"></span>
                  </div>
                </div>
                <div class="box fieldHideable icon-box">
                  <!-- <div class="icon" title="Party Size">
                    <i class="material-icons">people_alt</i>
                    <span id="field-worshipPartySize">6 ft</span>
                  </div> -->
                  <div class="icon" title="Social Distancing">
                    <i class="material-icons">sync_alt</i>
                    <span id="field-worshipSocialDistancing">50 or less</span>
                  </div>
                  <div class="icon percent" title="Occupancy">
                    <i class="material-icons">contacts</i>
                    <span id="field-worshipOccupacy">50%</span>
                  </div>
                </div>
              </div>
              <div class="group fieldHideable">
                <div class="source">
                  For more information:
                  <a
                    href="link"
                    class="link-medicalLink"
                    id="field-medicalSource"
                    >Source</a
                  >
                </div>
                <h5>
                  Elective Medical<span id="special-medicalOpen"
                    >: Not Permitted</span
                  >
                </h5>
                <div class="groupChart"></div>
                <div class="main">
                  <div>
                    <label>Procedure: </label>
                    <span id="field-medicalOvernightStays">Not Permitted</span>
                  </div>
                  <div>
                    <label>Stay Overnight: </label>
                    <span id="field-medicalProcedures">Permitted</span>
                  </div>
                </div>
              </div>
              <div class="group fieldHideable">
                <div class="source">
                  For more information:
                  <a
                    href="link"
                    class="link-schoolsLink"
                    id="field-schoolsSource"
                    >Source</a
                  >
                </div>
                <h5>Schools<span id="special-schoolsOpen">: Closed</span></h5>
                <div class="groupChart"></div>
                <div class="main"></div>
              </div>
              <div class="group fieldHideable">
                <div class="source">
                  For more information:
                  <a
                    href="link"
                    class="link-childcareLink"
                    id="field-childcareSource"
                    >Source</a
                  >
                </div>
                <h5>
                  Childcare<span id="special-childcareOpen">: Closed</span>
                </h5>
                <div class="groupChart"></div>
                <div class="main">
                  <table class="requirements">
                    <tr>
                      <th></th>
                      <th>Customers</th>
                      <th>Employees</th>
                    </tr>
                    <tr>
                      <td><label>Face Covering</label></td>
                      <td id="field-childcareMasksCust"></td>
                      <td id="field-childcareMasksEm"></td>
                    </tr>
                    <tr>
                      <td><label>Screening</label></td>
                      <td id="field-childcareScreeningCust"></td>
                      <td id="field-childcareScreeningEm"></td>
                    </tr>
                  </table>
                </div>
                <div class="box fieldHideable icon-box">
                  <div class="icon" title="Social Distancing">
                    <i class="material-icons">sync_alt</i>
                    <span id="field-childcareSocialDistancing">6 ft</span>
                  </div>
                  <div class="icon percent" title="Occupancy">
                    <i class="material-icons">contacts</i>
                    <span id="field-childcareOccupacy">50%</span>
                  </div>
                </div>
              </div>
              <div class="group public">
                <div class="source">
                  For more information:
                  <a href="link" class="link-publicLink" id="field-publicSource"
                    >Source</a
                  >
                </div>
                <h5>Public Rec. Areas</h5>
                <div class="groupChart"></div>
                <div class="main">
                  <div>
                    <label>Negative COVID Test: </label>
                    <span id="field-publicNegativeCovidTest"></span>
                  </div>
                </div>
                <div class="main mb-3">
                  <!-- <div class="openClose" id="openClose-publicOpenPlaygrounds">
                    <i class="material-icons">lens</i>
                    <span>Playgrounds</span>
                  </div> -->
                  <div class="openClose" id="openClose-publicOpenStateParks">
                    <i class="material-icons">lens</i>
                    <span>State Parks</span>
                  </div>
                  <!-- <div
                    class="openClose"
                    id="openClose-publicOpenParkFacilities"
                  >
                    <i class="material-icons">lens</i>
                    <span>Park Facilities</span>
                  </div> -->
                  <div class="openClose" id="openClose-publicOpenBeaches">
                    <i class="material-icons">lens</i>
                    <span>Beaches</span>
                  </div>
                  <!-- <div class="openClose" id="openClose-publicOpenBoating">
                    <i class="material-icons">lens</i>
                    <span>Boating</span>
                  </div>
                  <div
                    class="openClose"
                    id="openClose-publicOpenHuntingFishing"
                  >
                    <i class="material-icons">lens</i>
                    <span>Hunting / Fishing</span>
                  </div>
                  <div class="openClose" id="openClose-publicOpenCampgrounds">
                    <i class="material-icons">lens</i>
                    <span>Campgrounds</span>
                  </div>
                  <div class="openClose" id="openClose-publicOpenTennisCourts">
                    <i class="material-icons">lens</i>
                    <span>Tennis Courts</span>
                  </div>
                  <div class="openClose" id="openClose-publicOpenGolfCourses">
                    <i class="material-icons">lens</i>
                    <span>Golf Courses</span>
                  </div> -->
                </div>
                <div class="box fieldHideable icon-box">
                  <!-- <div class="icon" title="Party Size">
                    <i class="material-icons">people_alt</i>
                    <span id="field-publicPartySize">50 or less</span>
                  </div> -->
                  <div class="icon" title="Social Distancing">
                    <i class="material-icons">sync_alt</i>
                    <span id="field-publicSocialDistancing">6 ft</span>
                  </div>
                </div>
              </div>
              <div class="group fieldHideable">
                <div class="source">
                  For more information:
                  <a href="link" class="link-peopleLink" id="field-peopleSource"
                    >Source</a
                  >
                </div>
                <h5>Businesses</h5>
                <div class="groupChart"></div>

                <div class="main">
                  <table class="requirements fieldHideable">
                    <tr>
                      <th></th>
                      <th>Customers</th>
                      <th>Employees</th>
                    </tr>
                    <tbody class="fieldHideable">
                      <tr>
                        <th class="text-left header" colspan="3">
                          <h6>
                            Retail
                          </h6>
                          <a
                            class="link-retailLink more-info"
                            href=""
                            target="_blank"
                            title="More information"
                          >
                            <i class="material-icons">information</i>
                          </a>
                          <div class="fieldHideable icon-box float-right">
                            <div class="icon" title="Social Distancing">
                              <i class="material-icons">sync_alt</i>
                              <span id="field-retailSocialDistancing"
                                >50 or less</span
                              >
                            </div>
                            <div class="icon percent" title="Occupancy">
                              <i class="material-icons">contacts</i>
                              <span id="field-retailOccupacy">50%</span>
                            </div>
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <td class="text-right">
                          <label>Face Covering</label>
                        </td>
                        <td id="field-retailMasksCust"></td>
                        <td id="field-retailMasksEm"></td>
                      </tr>
                      <!-- <tr>
                        <td class="text-right">
                          <label>Screening</label>
                        </td>
                        <td id="field-retailScreenCust"></td>
                        <td id="field-retailScreenEmp"></td>
                      </tr> -->
                    </tbody>
                    <tbody class="fieldHideable">
                      <tr>
                        <th class="text-left header" colspan="3">
                          <h6>Dine-In Restaurants</h6>
                          <a
                            class="link-restaurantsLink more-info"
                            href=""
                            target="_blank"
                            title="More information"
                          >
                            <i class="material-icons">information</i>
                          </a>
                          <div class="fieldHideable icon-box float-right">
                            <!-- <div class="icon" title="Party Size">
                              <i class="material-icons">people_alt</i>
                              <span id="field-restaurantsPartySize">6 ft</span>
                            </div> -->
                            <div class="icon" title="Social Distancing">
                              <i class="material-icons">sync_alt</i>
                              <span id="field-restaurantsSocialDistancing"
                                >50 or less</span
                              >
                            </div>
                            <div class="icon percent" title="Occupancy">
                              <i class="material-icons">contacts</i>
                              <span id="field-restaurantsOccupacy">50%</span>
                            </div>
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <td class="text-right">
                          <label>Face Covering</label>
                        </td>
                        <td id="field-restaurantsMasksCust"></td>
                        <td id="field-restaurantsMasksEm"></td>
                      </tr>
                      <!-- <tr>
                        <td class="text-right">
                          <label>Screening</label>
                        </td>
                        <td id="field-restaurantsScreeningCust"></td>
                        <td id="field-restaurantsScreeningEm"></td>
                      </tr> -->
                    </tbody>
                    <tbody class="fieldHideable">
                      <tr>
                        <th class="text-left header" colspan="3">
                          <h6>Nightclubs and Bars</h6>
                          <a
                            class="link-barsLink more-info"
                            href=""
                            target="_blank"
                            title="More information"
                          >
                            <i class="material-icons">information</i>
                          </a>
                          <div class="fieldHideable icon-box float-right">
                            <!-- <div class="icon" title="Party Size">
                              <i class="material-icons">people_alt</i>
                              <span id="field-barsPartySize">6 ft</span>
                            </div> -->
                            <div class="icon" title="Social Distancing">
                              <i class="material-icons">sync_alt</i>
                              <span id="field-barsSocialDistancing"
                                >50 or less</span
                              >
                            </div>
                            <div class="icon percent" title="Occupancy">
                              <i class="material-icons">contacts</i>
                              <span id="field-barsOccupacy">50%</span>
                            </div>
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <td class="text-right">
                          <label>Face Covering</label>
                        </td>
                        <td id="field-barsMasksCust"></td>
                        <td id="field-barsMasksEm"></td>
                      </tr>
                      <!-- <tr>
                        <td class="text-right">
                          <label>Screening</label>
                        </td>
                        <td id="field-barsScreeningCust"></td>
                        <td id="field-barsScreeningEm"></td>
                      </tr> -->
                    </tbody>
                    <tbody class="fieldHideable">
                      <tr>
                        <th class="text-left header" colspan="3">
                          <h6>Entertainment Venues</h6>
                          <a
                            class="link-entretainmentLink more-info"
                            href=""
                            target="_blank"
                            title="More information"
                          >
                            <i class="material-icons">information</i>
                          </a>
                          <div class="fieldHideable icon-box float-right">
                            <!-- <div class="icon" title="Party Size">
                              <i class="material-icons">people_alt</i>
                              <span id="field-entretainmentPartySize"
                                >6 ft</span
                              >
                            </div> -->
                            <div class="icon" title="Social Distancing">
                              <i class="material-icons">sync_alt</i>
                              <span id="field-entretainmentSocialDistancing"
                                >50 or less</span
                              >
                            </div>
                            <div class="icon percent" title="Occupancy">
                              <i class="material-icons">contacts</i>
                              <span id="field-entretainmentOccupacy">50%</span>
                            </div>
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <td class="text-right">
                          <label>Face Covering</label>
                        </td>
                        <td id="field-entretainmentMasksCust"></td>
                        <td id="field-entretainmentMasksEm"></td>
                      </tr>
                      <!-- <tr>
                        <td class="text-right">
                          <label>Screening</label>
                        </td>
                        <td id="field-entretainmentScreeningCust"></td>
                        <td id="field-entretainmentScreeningEm"></td>
                      </tr> -->
                    </tbody>
                    <tbody class="fieldHideable">
                      <tr>
                        <th class="text-left header" colspan="3">
                          <h6>Athletic Facilities</h6>
                          <a
                            class="link-gymsLink more-info"
                            href=""
                            target="_blank"
                            title="More information"
                          >
                            <i class="material-icons">information</i>
                          </a>
                          <div class="fieldHideable icon-box float-right">
                            <div class="icon" title="Social Distancing">
                              <i class="material-icons">sync_alt</i>
                              <span id="field-gymsSocialDistancing"
                                >50 or less</span
                              >
                            </div>
                            <div class="icon percent" title="Occupancy">
                              <i class="material-icons">contacts</i>
                              <span id="field-gymsOccupacy">50%</span>
                            </div>
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <td class="text-right">
                          <label>Face Covering</label>
                        </td>
                        <td id="field-gymsMasksCust"></td>
                        <td id="field-gymsMasksEm"></td>
                      </tr>
                      <!-- <tr>
                        <td class="text-right">
                          <label>Screening</label>
                        </td>
                        <td id="field-gymsScreeningCust"></td>
                        <td id="field-gymsScreeningEm"></td>
                      </tr> -->
                    </tbody>
                    <tbody class="fieldHideable">
                      <tr>
                        <th class="text-left header" colspan="3">
                          <h6>Close-Contact Biz (eg, salons)</h6>
                          <a
                            class="link-closeContactBizLink more-info"
                            href=""
                            target="_blank"
                            title="More information"
                          >
                            <i class="material-icons">information</i>
                          </a>
                          <div class="fieldHideable icon-box float-right">
                            <div class="icon" title="Social Distancing">
                              <i class="material-icons">sync_alt</i>
                              <span id="field-closeContactBizSocialDistancing"
                                >50 or less</span
                              >
                            </div>
                            <div class="icon percent" title="Occupancy">
                              <i class="material-icons">contacts</i>
                              <span id="field-closeContactBizOccupacy"
                                >50%</span
                              >
                            </div>
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <td class="text-right">
                          <label>Face Covering</label>
                        </td>
                        <td id="field-closeContactBizMasksCust">
                          Required
                        </td>
                        <td id="field-closeContactBizMasksEm">
                          Required
                        </td>
                      </tr>
                      <!-- <tr>
                        <td class="text-right">
                          <label>Screening</label>
                        </td>
                        <td id="field-closeContactBizScreeningCust">
                          Required
                        </td>
                        <td id="field-closeContactBizScreeningEm">
                          Required
                        </td>
                      </tr> -->
                    </tbody>
                  </table>
                </div>
                <div class="prohibited mt-2 fieldHideable">
                  <label class="header">Venue Details</label>
                  <div class="fieldHideable">
                    <label>Live Music in Restaurants: </label>
                    <span id="field-bizProhibitedDineInEntretainment"></span>
                  </div>
                  <div class="fieldHideable">
                    <label>Gyms:</label>
                    <div class="fieldHideable pl-3">
                      <label>Indoor Pools: </label>
                      <span
                        id="field-bizProhibitedAthleticFacilitiesPools"
                      ></span>
                    </div>
                    <div class="fieldHideable pl-3">
                      <label>Spas: </label>
                      <span
                        id="field-bizProhibitedAthleticFacilitiesSpas"
                      ></span>
                    </div>
                    <div class="fieldHideable pl-3">
                      <label>Showers: </label>
                      <span
                        id="field-bizProhibitedAthleticFacilitiesShowers"
                      ></span>
                    </div>
                    <div class="fieldHideable pl-3">
                      <label>Saunas: </label>
                      <span
                        id="field-bizProhibitedAthleticFacilitiesSaunas"
                      ></span>
                    </div>
                    <div class="fieldHideable pl-3">
                      <label>Indoor group classes: </label>
                      <span
                        id="field-bizProhibitedAthleticFacilitiesIndoorGroupClasses"
                      ></span>
                    </div>
                    <div class="fieldHideable pl-3">
                      <label>Close-Contact Sports: </label
                      >
                      <span
                        id="field-bizProhibitedAthleticFacilitiesCloseContactAthletics"
                      ></span>
                    </div>
                    <!-- <div class="fieldHideable">
                      <label>Close-Contact Biz (Can remove masks for services):</label>
                      <span id="field-bizProhibitedCloseContactBizRemovalOMasks"></span>
                    </div> -->
                  </div>
                </div>
              </div>

              <table id="reopeningTable" class="sites-table stripped"></table>
              <!-- <table>
                <tr>
                  <th>Status</th>
                  <th>As of 5/9/2020</th>
                  <th>Restrictions and Exceptions</th>
                </tr>
              </table> -->
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel class="card county-profile" v-show="profile.showCounty">
          <v-expansion-panel-header class="card-header pa-1">
            <h2
              class="mb-0"
              data-toggle="collapse"
              data-target="#collapseCounty"
              aria-expanded="false"
              aria-controls="collapseCounty"
            >
              <span class="name">State</span>
            </h2>
          </v-expansion-panel-header>
          <v-expansion-panel-content id="collapseCounty">
            <div class="card-body">
              <label class="ma-0">
                <i class="cases-icon"></i>
                <span class="cases"></span>
              </label>
              <label class="ma-0">
                <i class="test-site-icon material-icons">lens</i>
                <span class="numTestSites"></span>
              </label>
              <label class="ma-0">
                <i class="trial-site-icon material-icons">lens</i>
                <span class="numTrialSites"></span>
              </label>
              <div id="countyCasesChartWrapper">
                <div id="countyCasesChart"></div>
              </div>

              <!-- <h5 class="mt-3 test-sites-banner banner">
                Test Sites
              </h5>
              <div class="test-sites-toggles criteria-toggles flex-wrap">
                <div class="group">
                  <div class="criteria-toggle needAppointment">
                    <i class="material-icons">event_available</i>
                    Appointment needed
                  </div>
                </div>
                <div class="group">
                  <div class="criteria-toggle prescriptionRequired">
                    <i class="material-icons">list_alt</i>
                    Prescription/referral required
                  </div>
                </div>
                <div class="group">
                  <div class="criteria-toggle antibodyTest">
                    <i class="material-icons">science</i>
                    Antibody
                  </div>
                </div>
              </div>
              <table id="testSitesTable" class="sites-table stripped"></table> -->
              <!-- <h5 class="mt-3 clinical-trials-banner banner">
                Clinical Trials
              </h5>
              <div class="criteria-trials-toggles criteria-toggles flex-wrap">
                <div class="group">
                  <div class="criteria-toggle mustBeCovidPositive">
                    <i class="material-icons">coronavirus</i>
                    Must be COVID-positive
                  </div>
                </div>
                <div class="group">
                  <div class="criteria-toggle hasCompensation">
                    <i class="material-icons">attach_money</i>
                    Has compensation
                  </div>
                </div>
              </div>
              <table id="trialSitesTable" class="sites-table stripped"></table> -->
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel class="card test-site-profile" v-show="profile.showTestSites">
          <v-expansion-panel-header class="card-header pa-1">
            <h2
              class="mb-0"
              data-toggle="collapse"
              data-target="#collapseTestSite"
              aria-expanded="false"
              aria-controls="collapseTestSite"
            >
              Test Site
            </h2>
          </v-expansion-panel-header>
          <v-expansion-panel-content id="collapseTestSite">
            <div class="card-body">
              <div class="site-info"></div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel class="card trial-site-profile" v-show="profile.showClinicalTrials">
          <v-expansion-panel-header class="card-header pa-1">
            <h2
              class="mb-0"
              data-toggle="collapse"
              data-target="#collapseTrialSite"
              aria-expanded="false"
              aria-controls="collapseTrialSite"
            >
              Clinical Trial
            </h2>
          </v-expansion-panel-header>
          <v-expansion-panel-content id="collapseTrialSite">
            <div class="card-body">
              <div class="site-info"></div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3"
import _ from "lodash"
import moment from "moment"
import * as topojson from "topojson-client"
import $ from "jquery"

let green = "#329c00"
let red = "#e20000"
let yellow = "#f9df00"
let gray = "#999999"

let lineColor = "hsl(0, 100%, 54%)"
let dotColorHover = "hsl(358, 81%, 39%)"
let casesColor = "hsl(11, 94%, 65%)"
let casesColorHover = "hsl(2, 74%, 51%)"
let casesComparedColor = "hsl(231, 94%, 65%)"
let casesComparedColorHover = "hsl(222, 74%, 51%)"

var margin = { top: 20, right: 20, bottom: 30, left: 90 },
  width = 850 - margin.left - margin.right,
  height = 300 - margin.top - margin.bottom
var timeoutId = null
// var path = d3.geoPath().projection(d3.geoStereographic()
//     .scale(width)
//     .translate([width, height * 1.4])
//     .rotate([-100, -20])
//     .clipAngle(180 - 1e-4)
//     // .clipExtent([[0, 0], [width, height]])
//     .precision(0.2))
var zoom = d3.zoom()

let formatNoDecimal = d3.format(",.0f")
let format = d3.format(",")

var viewBox = {
  minX: 31,
  minY: 6,
  width: 866,
  height: 500
}

var mapCounties = null
var mapStates = null
// var mapCountyTitles = null
var mapTestSites = null
var mapClinicalTrials = null

var testSitesShown = true
var clinicalTrialsShown = true

let testSitesDotColor = "#89c0d7"
// let clinicalTrialsDotColor = "#da87da"
let clinicalTrialsDotColor = "#73d473"
let stateStroke = "hsl(208, 89%, 51%)"
let countyStroke = "hsl(208, 89%, 51%)"
let countyColor = "rgb(255,245,240)"

let stateCodes = [
  { name: "Alabama", code: "AL" },
  { name: "Alaska", code: "AK" },
  { name: "Arizona", code: "AZ" },
  { name: "Arkansas", code: "AR" },
  { name: "California", code: "CA" },
  { name: "Colorado", code: "CO" },
  { name: "Connecticut", code: "CT" },
  { name: "Delaware", code: "DE" },
  { name: "District of Columbia", code: "DC" },
  { name: "Florida", code: "FL" },
  { name: "Georgia", code: "GA" },
  { name: "Hawaii", code: "HI" },
  { name: "Idaho", code: "ID" },
  { name: "Illinois", code: "IL" },
  { name: "Indiana", code: "IN" },
  { name: "Iowa", code: "IA" },
  { name: "Kansas", code: "KS" },
  { name: "Kentucky", code: "KY" },
  { name: "Louisiana", code: "LA" },
  { name: "Maine", code: "ME" },
  { name: "Maryland", code: "MD" },
  { name: "Massachusetts", code: "MA" },
  { name: "Michigan", code: "MI" },
  { name: "Minnesota", code: "MN" },
  { name: "Mississippi", code: "MS" },
  { name: "Missouri", code: "MO" },
  { name: "Montana", code: "MT" },
  { name: "Nebraska", code: "NE" },
  { name: "Nevada", code: "NV" },
  { name: "New Hampshire", code: "NH" },
  { name: "New Jersey", code: "NJ" },
  { name: "New Mexico", code: "NM" },
  { name: "New York", code: "NY" },
  { name: "North Carolina", code: "NC" },
  { name: "North Dakota", code: "ND" },
  { name: "Ohio", code: "OH" },
  { name: "Oklahoma", code: "OK" },
  { name: "Oregon", code: "OR" },
  { name: "Pennsylvania", code: "PA" },
  { name: "Rhode Island", code: "RI" },
  { name: "South Carolina", code: "SC" },
  { name: "South Dakota", code: "SD" },
  { name: "Tennessee", code: "TN" },
  { name: "Texas", code: "TX" },
  { name: "Utah", code: "UT" },
  { name: "Vermont", code: "VT" },
  { name: "Virginia", code: "VA" },
  { name: "Washington", code: "WA" },
  { name: "West Virginia", code: "WV" },
  { name: "Wisconsin", code: "WI" },
  { name: "Wyoming", code: "WY" },
  { name: "American Samoa", code: "AS" },
  { name: "Guam", code: "GU" },
  { name: "Marshall Islands", code: "MH" },
  { name: "Micronesia", code: "FM" },
  { name: "Northern Marianas", code: "MP" },
  { name: "Palau", code: "PW" },
  { name: "Puerto Rico", code: "PR" },
  { name: "Virgin Islands", code: "VI" }
]

let sum = (a, b) => a + b

let mainData = {
  getStateMinMax: (() => {
    let x
    return () => {
      if (!x) {
        x = mainData.stateMinMaxFn()
      }
      return x
    }
  })()
}

let testSiteTooltipHtml = d => `
<a class='siteName' href="${d.Website}">${d["Name of Facility"]}</a> <br/>
<label>Contact:</label>
<span>${d.Phone || ""}</span> <br/>
`
let clinicalTooltipHtml = d => `
<a class='siteName' href="${d["Link"]}">${d["Trial Name"]}</a> <br/>
<label>Contact:</label>
<span>${d["Contact Number (1)"]}</span><br/>
`

let testSiteProfileHtml = d => `
<a class='siteName' href="${d.Website}">${d["Name of Facility"]}</a> <br/>
<table class="site-details stripped">
  <tr><th>Country</th><td>${d.stateName || ""}</td></tr>
  <tr><th>Province</th><td>${d.County || ""}</td></tr>
  <tr><th>City</th><td>${d.Municipality || ""}</td></tr>
  <tr><th>Status</th><td>${d.Status || ""}</td></tr>
  <tr><th>Owner Type</th><td>${d["Owner Type"] || ""}</td></tr>
  <tr><th>Phone</th><td>${d.Phone || ""}</td></tr>
  <tr><th>Open Hours</th><td>${d["Operational Hours"] || ""}</td></tr>
  <tr><th>Comments</th><td>${d.Comments || ""}</td></tr>
  <tr><th>Instructions</th><td>${d.Instructions || ""}</td></tr>
  <tr><th>Drive-through</th><td>${d["Drive-through"] || ""}</td></tr>
  <tr><th>Appointment Only</th><td>${d["Appointment Only"] || ""}</td></tr>
  <tr><th>Referral Required</th><td>${d["Referral Required"] || ""}</td></tr>
  <tr><th>Call first</th><td>${d["Call first"] || ""}</td></tr>
  <tr><th>Virtual/Telehealth Screening</th><td>${d[
    "Virtual/Telehealth Screening"
  ] || ""}</td></tr>
</table>
`
let clinicalProfileHtml = d => `
<a class='siteName' href="${d["Link"]}">${d["Trial Name"]}</a> <br/>
<table class="site-details">
  <tr><th>Country</th><td>${d["State"] || "-"}</td></tr>
  <tr><th>Province</th><td>${d["County"] || "-"}</td></tr>
  <tr><th>City</th><td>${d["City"] || "-"}</td></tr>
  <tr><th>Trial Name</th><td>${d["Trial Name"] || "-"}</td></tr>
  <tr><th>Link</th><td>${d["Link"] || "-"}</td></tr>
  <tr><th>Age</th><td>${d["Age"] || "-"}</td></tr>
  <tr><th>Sex</th><td>${d["Sex"] || "-"}</td></tr>
  <tr><th>Healthy Volunteers</th><td>${d["Healthy Volunteers"] || "-"}</td></tr>
  <tr><th>Volunteer can be a PUI for COVID-19</th><td>${
    d["Volunteer can be a PUI for COVID-19"] || "-"
  }</td></tr>
  <tr><th>Volunteer can have a positive COVID-19 test</th><td>${
    d["Volunteer can have a positive COVID-19 test"] || "-"
  }</td></tr>
  <tr><th>Volunteer can have ARDS Associated with COVID-19</th><td>${
    d["Volunteer can have ARDS Associated with COVID-19"] || "-"
  }</td></tr>
  <tr><th>Volunteer can be hospitalized</th><td>${
    d["Volunteer can be hospitalized"] || "-"
  }</td></tr>
  <tr><th>Volunteer can be on a ventilator</th><td>${
    d["Volunteer can be on a ventilator"] || "-"
  }</td></tr>
  <tr><th>Volunteer can be pregnant/ breastfeeding at any point during the study</th><td>${
    d["Volunteer can be pregnant/ breastfeeding at any point during the study"] || "-" || "-"
  }</td></tr>
  <tr><th>Autoimmune disorder</th><td>${d["Autoimmune disorder"] || "-"}</td></tr>
  <tr><th>Known allergies to components of the vaccine or drugs used in clinical trial (i.e., hydroxychloroquine, chloroquine, or amodiaquine)</th><td>${
    d[
      "Known allergies to components of the vaccine or drugs used in clinical trial (i.e., hydroxychloroquine, chloroquine, or amodiaquine)"
    ] || "-"
  }</td></tr>
  <tr><th>Negative Serology for HIV, HCV, HbsAg</th><td>${
    d["Negative Serology for HIV, HCV, HbsAg"] || "-"
  }</td></tr>
  <tr><th>Volunteer can participate in multiple clinical trials during or within 30 days of the study duration</th><td>${
    d[
      "Volunteer can participate in multiple clinical trials during or within 30 days of the study duration"
    ] || "-"
  }</td></tr>
  <tr><th>End-organ damage or compromised (i.e., heart, kidney, eyes,  liver)</th><td>${
    d["End-organ damage or compromised (i.e., heart, kidney, eyes,  liver)"] || "-"
  }</td></tr>
  <tr><th>Enrollment</th><td>${d["Enrollment"] || "-"}</td></tr>
  <tr><th>Phase</th><td>${d["Phase"] || "-"}</td></tr>
  <tr><th>Status</th><td>${d["Status"] || "-"}</td></tr>
  <tr><th>Start Date</th><td>${moment("1900-01-01")
    .add(+d["Start Date"] - 2, "days")
    .format("MMM D, YYYY")}</td></tr>
  <tr><th>Completion Date</th><td>${moment("1900-01-01")
    .add(+d["Completion Date"] - 2, "days")
    .format("MMM D, YYYY")}</td></tr>
  <tr><th>Locations</th><td>${d["Locations"] || "-"}</td></tr>
  <tr><th>Contact Name (1)</th><td>${d["Contact Name (1)"] || "-"}</td></tr>
  <tr><th>Contact Number (1)</th><td>${d["Contact Number (1)"] || "-"}</td></tr>
  <tr><th>Contact Email (1)</th><td>${d["Contact Email (1)"] || "-"}</td></tr>
  <tr><th>NCT Number</th><td>${d["NCT Number"] || "-"}</td></tr>
  <tr><th>Sponsor/Collaborator</th><td>${d["Sponsor/Collaborator"] || "-"}</td></tr>
</table>
`

// window.v0 = null
// window.r0 = null
// window.q0 = null
// window.refresh = null
// window.path = null
// function dragstarted() {
//   v0 = versor.cartesian(proj.invert(d3.mouse(this)));
//   r0 = proj.rotate();
//   q0 = versor(r0);
// }
  
// function dragged() {
//   var v1 = versor.cartesian(proj.rotate(r0).invert(d3.mouse(this))),
//       q1 = versor.multiply(q0, versor.delta(v0, v1)),
//       r1 = versor.rotation(q1);
//   proj.rotate(r1);
//   window.renderMap(path);
// }

var projection = d3.geoStereographic()
export default {
  props: {},
  data: () => ({
    loading: true,
    latestDate: null,
    notScrolled: true,
    showHint: true,
    search: null,
    allLocations: [],
    level: "county", // 'state' or 'county'
    mode: "total",
    relativeToState: true,
    currentStateName: null,
    currentCountyId: null,
    // modes: [
    //   "casesState",
    //   "deathsState",
    //   "activeState",
    //   "cases",
    //   "deaths",
    //   "active",
    //   "casesChange"
    // ],
    ip: null,
    profilePanel: null,
    profile: {
      showState: false,
      showCounty: false,
      showTestSites: false,
      showClinicalTrials: false,
    }
  }),
  watch: {
    mode() {
      return this.modeChanged()
    },
    level() {
      return this.modeChanged()
    },
    relativeToState() {
      return this.modeChanged()
    },
    search() {
      if (!this.search) {
        return
      } else if (this.search.level == 0) { // country
        this.reset()
      } else if (this.search.level == 1) { // state
        this.zoomToState(this.search.value)
      } else if (this.search.level == 2 || this.search.level == 3) { // county
        let county = mainData.counties.find(d => d.properties.location_id == this.search.key)
        this.countyClicked(county)
  
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  created() {

    window.renderMap = this.renderMap
    window._d3 = d3
    console.log("created")

    window.instance = this
    
    // this.setPath(0.9, 0.6, 1, -75, -40)

    this.init().then(() => {
      setTimeout(() => {
        console.log("loaded")
        let dateTime = Date.now()
        let days = moment().diff('2019-12-31', 'days')
        document.querySelector("#myRange").max = days
        document.querySelector("#myRange").value = days
        document.querySelector("#myRange-top").max = days
        document.querySelector("#myRange-top").value = days
        let proj = d3.geoOrthographic()
            .translate([465,270])
            .rotate([-20,0])
            .scale(390,390)
        let path = d3.geoPath()
          .projection(proj)
        window.proj = proj
        window.path = path
        this.renderMap(path)
      setTimeout(() => {
        console.log((Date.now() - dateTime)/1)
        dateTime = Date.now()
        this.setDayData(days)
        console.log((Date.now() - dateTime)/1)
      setTimeout(() => {
        dateTime = Date.now()
        this.initCombosAndActions()
        console.log((Date.now() - dateTime)/1)
        dateTime = Date.now()
        console.log("done")
        this.loading = false
        
        d3.select(".map-frame svg")
          .transition()
          .duration(1000)
          .style("opacity", 1)
        d3.select(".map-frame .hint")
          .transition()
          .duration(1000)
          .style("opacity", 1)
        d3.select(".map-frame-wrapper .loading-map")
          .style("display", "none")
      setTimeout(() => {
        this.zoomToState("South Africa")
      },2000)
      },1)
      },1)
      },1)
    })
  },
  methods: {
    setPath(scaleX, translateScaleX, translateScaleY, rotateX, rotateY) {
      scaleX = scaleX || 1
      // scaleY = scaleY || 1
      translateScaleX = translateScaleX || 1
      translateScaleY = translateScaleY || 1.4
      rotateX = rotateX || -100
      rotateY = rotateY || -20
      path = d3.geoPath().projection(d3.geoOrthographic()
        .scale(width * scaleX)
        .translate([width * translateScaleX, height * translateScaleY])
        .rotate([rotateX, rotateY])
        // .clipAngle(180 - 1e-4)
        // .clipExtent([[0, 0], [width, height]])
        .precision(0.2))
    },
    handleScroll (event) {
      let target = document.getElementById("reopeningStatusChart")
      if (!target || !target.offsetTop) return
      
      if (this.notScrolled && window.pageYOffset > target.offsetTop + 20) {
        this.notScrolled = false
        console.log("passed!")
      }

      // console.log(event)

    },
    modeChanged() {
      let legendText = ""
      
      if (this.relativeToState && this.level == 'county') {
        if (this.mode == "total") {
          legendText = "Relative no. of province cases across country"
        } else if (this.mode == "active") {
          legendText = "Relative no. of active province cases across country"
        } else if (this.mode == "deaths") {
          legendText = "Relative no. of province deaths across country"
        } else if (this.mode == "trend") {
          legendText = "Active cases trend"
        }
      } else {
        if (this.mode == "total") {
          legendText = "Total cases"
        } else if (this.mode == "active") {
          legendText = "Active cases"
        } else if (this.mode == "deaths") {
          legendText = "Total deaths"
        } else if (this.mode == "trend") {
          legendText = "Active cases trend"
        }
      }

      d3.select("#legend #header")
        .text(legendText)
        .call(this.wrap, 180)

      let current = document.querySelector("#myRange").value
      this.setDayData(current)
    },
    createShowToolTip: function(tooltip, baseElement) {
      return function(html) {
        let chartRect = d3
          .select(baseElement)
          .node()
          .getBoundingClientRect()
        tooltip
          .transition()
          .duration(200)
          .style("opacity", 0.93)
        tooltip
          .html(html)
          .style("left", d3.event.clientX - chartRect.x + "px")
          .style("top", d3.event.clientY - chartRect.y - 28 + "px")
      }
    },

    createHideTooltip: function(tooltip) {
      return function() {
        tooltip
          .transition()
          .duration(500)
          .style("opacity", 0)
      }
    },

    renderMap(path) {
      console.log("drawing map")


      // Remove prevouis map if any
      d3.selectAll(".map-frame svg").remove()
      d3.selectAll(".tooltip").remove()

      // Create svg
      let viewBoxStr = `${viewBox.minX} ${viewBox.minY} ${viewBox.width} ${viewBox.height}`
      const mainSvg = d3
        .select(".map-frame")
        .append("svg")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("viewBox", viewBoxStr)
        .style("opacity", 0)
        .style("width", "100%")
        .style("transform", "translate3d(0, 0, 0)")
      const svg = mainSvg.append("g").attr("id", "country")

      svg
        .attr("transform", "translate(0,0)")
        .style("overflow", "visible")
        .style("width", "100%")
        .style("height", "auto")

      // mainSvg.call(d3.drag()
      //   .on("start", dragstarted)
      //   .on("drag", dragged));
      mainSvg
        // .call(dragMap)
        .call(
          zoom
            .scaleExtent([1, 10])
            .on("zoom", () => {
              svg
                .attr("transform", d3.event.transform)
                .attr("stroke-width", 1 / d3.event.transform.k)
            })
            .on("end", () => {
              let transform = d3.event.transform
              this.drawTestSites(transform.x, transform.y, transform.k)
              // d3.selectAll("g#clinicalTrials circle")
              //   .transition()
              //   .duration(250)
              //   .attr("r", `${2 / transform.k}px`)
            })
        )

      // Create legend
      const legend = mainSvg
        .append("g")
        .attr("id", "legend")
        .attr("transform", "translate(690,333)scale(0.8)")
      legend
        .append("rect")
        .attr("id", "frame")
        .attr("rx", 4)
        .attr("ry", 4)
        .attr("x", 0)
        .attr("y", 0)
        .attr("width", 225)
        .attr("height", 200)
        .attr("fill", "#dddc")
        .attr("stroke", "#ccc")

      legend
        .append("text")
        .attr("id", "legendTitle")
        .attr("x", 225 / 2)
        .attr("y", 20 + 2)
        .text("Africa")
        // .style("fill", "#333")
        .attr("alignment-baseline", "middle")
        .style("font-size", "16px")
        .style("font-weight", "700")
        .style("text-anchor", "middle")

      var legendTestSites = legend.append("g").attr("id", "legendTestSites")
      legendTestSites
        .append("circle")
        .attr("cx", 20)
        .attr("cy", 30 + 20)
        .attr("r", 6)
        .style("fill", testSitesDotColor)
      legendTestSites
        .append("text")
        .attr("x", 30)
        .attr("y", 30 + 20 + 2)
        .text("Test Sites")
        .style("fill", "hsl(212, 85%, 45%)")
        .style("font-size", "15px")
        .attr("alignment-baseline", "middle")
      legendTestSites
        .style("cursor", "pointer")
        .on("click", this.toggleTestSites)

      var legendClinicalTrials = legend
        .append("g")
        .attr("id", "legendClinicalTrials")
      legendClinicalTrials
        .append("circle")
        .attr("cx", 20)
        .attr("cy", 30 + 20 + 30)
        .attr("r", 6)
        .style("fill", clinicalTrialsDotColor)
      legendClinicalTrials
        .append("text")
        .attr("x", 30)
        .attr("y", 30 + 20 + 30 + 2)
        .text("Clinical Trials")
        .style("fill", "hsl(212, 85%, 45%)")
        .style("font-size", "15px")
        .attr("alignment-baseline", "middle")
      legendClinicalTrials
        .style("cursor", "pointer")
        .on("click", this.toggleClinicalTrials)

      var colors = [
        this.color2(0),
        this.color2(0.04),
        this.color2(0.16),
        this.color2(0.36),
        this.color2(0.64),
        this.color2(1)
      ]
      var grad = legend
        .append("defs")
        .append("linearGradient")
        .attr("id", "grad")
        .attr("x1", "0%")
        .attr("x2", "100%")
        .attr("y1", "0%")
        .attr("y2", "0%")

      grad
        .selectAll("stop")
        .data(colors)
        .enter()
        .append("stop")
        .style("stop-color", function(d) {
          return d
        })
        .attr("offset", function(d, i) {
          return 100 * (i / (colors.length - 1)) + "%"
        })

      legend
        .append("rect")
        .attr("x", 14)
        .attr("y", 30 + 70 - 40)
        .attr("width", 225 - 14 * 2)
        .attr("height", 15)
        .style("fill", "url(#grad)")
        .attr("transform", "translate(0,70)")
      legend
        .append("text")
        .attr("id", "header")
        .attr("x", 225 / 2)
        .attr("y", 30 + 70 + 50)
        .attr("alignment-baseline", "middle")
        .style("font-size", "15px")
        .style("text-anchor", "middle")
        .text("Relative no. of province cases across country")
        // .style("fill", "hsl(212, 85%, 45%)")
        // .style("cursor", "pointer")
        // .on("click", this.changeMode)
        .call(this.wrap, 180)
      legend
        .append("text")
        .attr("id", "lowCases")
        .attr("x", 14)
        .attr("y", 30 + 97 + 30 - 40)
        .text("Low cases")
        .style("font-size", "15px")
        .attr("alignment-baseline", "middle")
        .style("text-anchor", "start")
      legend
        .append("text")
        .attr("id", "highCases")
        .attr("x", 225 - 14)
        .attr("y", 30 + 97 + 30 - 40)
        .text("High cases")
        .style("font-size", "15px")
        .attr("alignment-baseline", "middle")
        .style("text-anchor", "end")

      let reopeningPanel = legend
        .append("g")
        .attr("id", "reopening")
        .style("display", "none")
        .attr("transform", "translate(0,247)")
      reopeningPanel
        .append("line")
        .attr("x1", 0)
        .attr("y1", "-20")
        .attr("x2", 225)
        .attr("y2", "-20")
        .attr("stroke", "#ccc")
      reopeningPanel
        .append("text")
        .attr("x", 225 / 2)
        .attr("y", 0)
        // .text("Cases relative to state")
        .attr("alignment-baseline", "middle")
        .style("font-size", "15px")
        .style("font-weight", "700")
        .style("text-anchor", "middle")
        .text("Reopening Status")
        .call(this.wrap, 180)

      // Define the div for the tooltip
      var tooltip = d3
        .select(".map-frame")
        .append("div")
        .attr("class", "tooltip")
        .style("opacity", 0)
      var tooltipLabel = d3
        .select(".map-frame")
        .append("div")
        .attr("class", "tooltip-label")
        .style("opacity", 0)


      let showTooltip = this.createShowToolTip(tooltip, ".map-frame")
      let showTooltipLabel = this.createShowToolTip(tooltipLabel, ".map-frame")
      let hideTooltip = this.createHideTooltip(tooltip)
      let hideTooltipLabel = this.createHideTooltip(tooltipLabel)

      // Draw provinces
      mapCounties = svg
        .append("g")
        .attr("id", "counties")
        .selectAll("path")
        .data(mainData.southAfricaProvinces)
        .enter()
        .append("path")
      mapCounties
        .attr("fill", d => countyColor)
        .attr("d", path)
        .on("mouseover", function(d) {
          d3.select(this)
            .attr("stroke", countyStroke)
            .raise()
          let locationId = d.properties.NAME_1
          let county = d.properties.NAME_1

          // Display Total Cases
          let days = document.querySelector("#myRange").value
          let date = moment("2020-01-01")
            .add(days - 1, "days")
            .format("YYYY-MM-DD")
          // let summary = mainData.casesData.filter(
          //   d => d.location === locationId && d.date <= date
          // )
          let summary = mainData.southAfricaCovidData.filter(
            d => d.county.toLowerCase() === locationId.toLowerCase() && d.date <= date
          )
          summary = _.orderBy(summary, ["date"], ["desc"])[0]
          let cases = summary ? summary.cases || 0 : 0
          let activeCases = summary ? summary.activeCases || 0 : 0
          let deaths = summary ? summary.deaths || 0 : 0
          showTooltipLabel(`<b>${county}</b>`
            + `<br>${format(activeCases)} active cases`
            + `<br>${format(cases)} total cases`
            // + `<br>${format(deaths)} deaths`
            )
          
          hideTooltip()
        })
        .on("mouseout", function() {
          d3.select(this)
            .attr("stroke", null)
            .lower()
          hideTooltipLabel()
        })
        .on("click", this.countyClicked)
      // mapCountyTitles = mapCounties
      //   .append("title")

      mapStates = svg
        .append("g")
        .attr("id", "states")
        .selectAll("path")
        .data(mainData.states)
        .enter()
        .append("path")
      mapStates
        .attr("fill", "#0000")
        .attr("stroke", "#fff")
        .attr("d", path)
        .on("mouseover", function(d) {
          d3.select(this)
            .attr("stroke", stateStroke)
            .raise()
          let state = d.properties.name || d.properties.admin

          // Display Total Cases
          let days = document.querySelector("#myRange").value
          let date = moment("2020-01-01")
            .add(days - 1, "days")
            .format("YYYY-MM-DD")
          let stateSummary = mainData.getStateMinMax().filter(
            d => d.state === state && d.date <= date
          )
          stateSummary = _.orderBy(stateSummary, ["date"], ["desc"])[0]
          let cases = stateSummary ? stateSummary.cases || 0 : 0
          let activeCases = stateSummary ? stateSummary.activeCases || 0 : 0
          let deaths = stateSummary ? stateSummary.deaths || 0 : 0

          showTooltipLabel(`<b>${state}</b>`
            + `<br>${format(activeCases)} active cases`
            + `<br>${format(cases)} total cases`
            + `<br>${format(deaths)} deaths`)
          hideTooltip()
        })
        .on("mouseout", function() {
          d3.select(this)
            .attr("stroke", "#fff")
            .lower()
          hideTooltip()
        })
        .on("click", this.stateClicked)

      svg
        .append("g")
        .attr("id", "testSites")
        .attr("fill", testSitesDotColor)
      svg
        .append("g")
        .attr("id", "clinicalTrials")
        .attr("fill", clinicalTrialsDotColor)
      this.drawTestSites()

      return svg.node()
    },

    drawTestSites: function(translateX, translateY, scale) {
      let testSitesCoordinates = mainData.testSites2
      let clinicalTrialCoordinates = mainData.clinicalTrialCoordinates

      if (
        (translateX === 0 || translateX) &&
        (translateY === 0 || translateY) &&
        (scale === 0 || scale)
      ) {
        let x1 = -translateX / scale
        let x2 = (-translateX + viewBox.width) / scale
        let y1 = -translateY / scale
        let y2 = (-translateY + viewBox.height) / scale

        testSitesCoordinates = testSitesCoordinates.filter(
          d => d.coordinates[0] >= x1
        )
        testSitesCoordinates = testSitesCoordinates.filter(
          d => d.coordinates[0] <= x2
        )
        testSitesCoordinates = testSitesCoordinates.filter(
          d => d.coordinates[1] >= y1
        )
        testSitesCoordinates = testSitesCoordinates.filter(
          d => d.coordinates[1] <= y2
        )
      }
      scale = scale || 1

      if (scale < 2) {
        testSitesCoordinates = []
        clinicalTrialCoordinates = []
      }

      // Initialize tooltips
      var tooltip = d3.select(".map-frame .tooltip")
      var tooltipLabel = d3.select(".map-frame .tooltip-label")

      let showTooltip = this.createShowToolTip(tooltip, ".map-frame")
      let showTooltipLabel = this.createShowToolTip(tooltipLabel, ".map-frame")
      let hideTooltip = this.createHideTooltip(tooltip)
      let hideTooltipLabel = this.createHideTooltip(tooltipLabel)

      // Draw test sites
      const svg = d3.select(".map-frame g#country")
      mapTestSites = svg
        .select("g#testSites")
        .selectAll("circle")
        .data(testSitesCoordinates, d => d.OBJECTID)
        .attr("r", `${2 / scale}px`)
      mapTestSites
        .enter()
        .append("circle")
        .style("opacity", 0)
        // .attr("r", 0)
        .attr("r", `${2 / scale}px`)
        .attr("cx", d => d.coordinates[0])
        .attr("cy", d => d.coordinates[1])
        // .attr("r", `${2/scale}px`)
        // .attr("r", "1.5px")
        .on("mouseover", d => {
          showTooltipLabel(testSiteTooltipHtml(d))
          hideTooltip()
        })
        .on("mouseout", d => {
          hideTooltip()
          hideTooltipLabel()
        })
        .transition()
        .duration(750)
        .style("opacity", 1)

      mapTestSites
        .exit()
        .transition()
        .duration(750)
        .style("opacity", 0)
        .remove()
        
      // TODO: filter to optimize
      // Draw clinical trial locations
      svg.select("g#clinicalTrials").selectAll("circle").remove()
      mapClinicalTrials = svg.select("g#clinicalTrials")
        .selectAll("circle")
        .data(clinicalTrialCoordinates)
        .enter()
        .append("circle")
      mapClinicalTrials
        .attr("cx", d => d.coordinates[0])
        .attr("cy", d => d.coordinates[1])
        .attr("r", `${2 / scale}px`)
        .on("mouseover", d => {
          showTooltip(clinicalTooltipHtml(d))
          hideTooltipLabel()
        })
        .on("mouseout", d => {
          hideTooltip()
        })

    },
    
    toLowerTrimmed(str) {
      if (!str || !str.toLowerCase) {
        return str
      }

      return str.toLowerCase().trim()
    },
    timeParse: d3.timeParse("%Y-%m-%d"),

    setToDay: async function(day) {
      this.logAction(`View Day (${day})`)

      document.querySelector("#myRange").value = day

      if (timeoutId) {
        clearTimeout(timeoutId)
        timeoutId = null
        d3.select(".play-btn .material-icons").text("play_arrow")
        await new Promise(r => setTimeout(r, 100))
      }

      this.setDayData(day)
    },

    // TODO: generalize on second+ country info
    getSouthAfricaCasesOfDay: function(casesData, date) {
      let data = casesData

      // filter by date
      let dates = data.map(d => d.date)
      dates = [...new Set(dates)] // uniq
      dates = dates.filter(d => moment(d).isSameOrBefore(date))
      dates.sort()
      let latest = dates[dates.length - 1]
      data = data.filter(d => d.date == latest)

      // set max cases by state in each record
      let maxActiveCasesCountry = Math.max(0, ...data.map(d => +d.activeCases))
      let maxCasesCountry = Math.max(0, ...data.map(d => +d.cases))
      let maxDeathsCountry = Math.max(0, ...data.map(d => +d.deaths))
      let groupedByState = this.groupBy(data, "state")
      for (let ix in groupedByState) {
        let arr = groupedByState[ix]
        let maxActiveCasesState = Math.max(0, ...arr.map(d => +d.activeCases))
        let maxCasesState = Math.max(0, ...arr.map(d => +d.cases))
        let maxDeathsState = Math.max(0, ...arr.map(d => +d.deaths))

        arr.forEach(d => {
          d.activeCasesRelativeToState =
            maxActiveCasesState == 0 ? 0 : +d.activeCases / maxActiveCasesState
          d.activeCasesRelativeToCountry =
            maxActiveCasesCountry == 0
              ? 0
              : +d.activeCases / maxActiveCasesCountry

          d.maxCasesState = maxCasesState
          d.casesRelativeToState =
            maxCasesState == 0 ? 0 : +d.cases / maxCasesState
          d.casesRelativeToCountry =
            maxCasesCountry == 0 ? 0 : +d.cases / maxCasesCountry

          d.maxDeathsState = maxDeathsState
          d.deathsRelativeToState =
            maxDeathsState == 0 ? 0 : +d.deaths / maxDeathsState
          d.deathsRelativeToCountry =
            maxDeathsCountry == 0 ? 0 : +d.deaths / maxDeathsCountry
        })
      }

      data = data.map(d => ({
        location: d.county.toLowerCase(),
        // location: d.location,
        state: d.state,
        // cases: [0, +d.cases],
        info: {
          activeCasesRelativeToState: +d.activeCasesRelativeToState,
          activeCasesRelativeToCountry: +d.activeCasesRelativeToCountry,

          cases: +d.cases,
          casesRelativeToState: +d.casesRelativeToState,
          casesRelativeToCountry: +d.casesRelativeToCountry,
          newCases: +d.newCases,
          difCasesPct: +d.difCasesPct,
          difCases: +d.difCases,
          deaths: +d.deaths,
          deathsRelativeToState: +d.deathsRelativeToState,
          deathsRelativeToCountry: +d.deathsRelativeToCountry,
          newDeaths: +d.newDeaths,
          difDeathsPct: +d.difDeathsPct,
          difDeaths: +d.difDeaths,
          activeCases: +d.activeCases
        }
      }))
      let records = new Map(
        Array.from(data, ({ location, info }) => [location, info])
      )

      return {
        maxActiveCasesCountry,
        maxCasesCountry,
        maxDeathsCountry,
        byCounty: records
      }
    },

    getCasesOfDay: function(casesData, date) {
      let data = casesData

      // filter by date
      let dates = data.map(d => d.date)
      dates = [...new Set(dates)] // uniq
      dates = dates.filter(d => moment(d).isSameOrBefore(date))
      dates.sort()
      let latest = dates[dates.length - 1]
      data = data.filter(d => d.date == latest)

      // set max cases by state in each record
      let maxActiveCasesCountry = Math.max(0, ...data.map(d => +d.activeCases))
      let maxCasesCountry = Math.max(0, ...data.map(d => +d.cases))
      let maxDeathsCountry = Math.max(0, ...data.map(d => +d.deaths))
      let groupedByState = this.groupBy(data, "state")
      for (let ix in groupedByState) {
        let arr = groupedByState[ix]
        let maxActiveCasesState = Math.max(0, ...arr.map(d => +d.activeCases))
        let maxCasesState = Math.max(0, ...arr.map(d => +d.cases))
        let maxDeathsState = Math.max(0, ...arr.map(d => +d.deaths))

        arr.forEach(d => {
          d.activeCasesRelativeToState =
            maxActiveCasesState == 0 ? 0 : +d.activeCases / maxActiveCasesState
          d.activeCasesRelativeToCountry =
            maxActiveCasesCountry == 0
              ? 0
              : +d.activeCases / maxActiveCasesCountry

          d.maxCasesState = maxCasesState
          d.casesRelativeToState =
            maxCasesState == 0 ? 0 : +d.cases / maxCasesState
          d.casesRelativeToCountry =
            maxCasesCountry == 0 ? 0 : +d.cases / maxCasesCountry

          d.maxDeathsState = maxDeathsState
          d.deathsRelativeToState =
            maxDeathsState == 0 ? 0 : +d.deaths / maxDeathsState
          d.deathsRelativeToCountry =
            maxDeathsCountry == 0 ? 0 : +d.deaths / maxDeathsCountry
        })
      }

      data = data.map(d => ({
        // location: d.county,
        // location: d.county,
        // location: d.location,
        state: d.state,
        // cases: [0, +d.cases],
        info: {
          activeCasesRelativeToState: +d.activeCasesRelativeToState,
          activeCasesRelativeToCountry: +d.activeCasesRelativeToCountry,

          cases: +d.cases,
          casesRelativeToState: +d.casesRelativeToState,
          casesRelativeToCountry: +d.casesRelativeToCountry,
          newCases: +d.newCases,
          difCasesPct: +d.difCasesPct,
          difCases: +d.difCases,
          deaths: +d.deaths,
          deathsRelativeToState: +d.deathsRelativeToState,
          deathsRelativeToCountry: +d.deathsRelativeToCountry,
          newDeaths: +d.newDeaths,
          difDeathsPct: +d.difDeathsPct,
          difDeaths: +d.difDeaths,
          activeCases: +d.activeCases
        }
      }))
      let records = new Map(
        Array.from(data, ({ location, info }) => [location, info])
      )

      return {
        maxActiveCasesCountry,
        maxCasesCountry,
        maxDeathsCountry,
        byCounty: records
      }
    },

    getStateCases: function(data, date) {
      // filter by date
      let dates = data.map(d => d.date)
      dates = [...new Set(dates)] // uniq
      dates = dates.filter(d => moment(d).isSameOrBefore(date))
      dates.sort()
      let latest = dates[dates.length - 1]
      data = data.filter(d => d.date == latest)

      // set max cases by state in each record
      let maxActiveCasesCountry = Math.max(0, ...data.map(d => +d.activeCases))
      let maxCasesCountry = Math.max(0, ...data.map(d => +d.cases))
      let maxDeathsCountry = Math.max(0, ...data.map(d => +d.deaths))

      data.forEach(d => {
        d.activeCasesRelativeToCountry =
          maxActiveCasesCountry == 0
            ? 0
            : +d.activeCases / maxActiveCasesCountry
        d.casesRelativeToCountry =
          maxCasesCountry == 0 ? 0 : +d.cases / maxCasesCountry
        d.deathsRelativeToCountry =
          maxDeathsCountry == 0 ? 0 : +d.deaths / maxDeathsCountry
      })

      let records = new Map(Array.from(data, d => [d.state, d]))

      return {
        maxActiveCasesCountry,
        maxCasesCountry,
        maxDeathsCountry,
        byState: records
      }
    },

    // changeMode: function(mode) {
    //   if (mode) {
    //     this.mode = mode
    //   } else {
    //     mode = this.mode
    //     this.mode = this.modes[(this.modes.indexOf(mode) + 1) % this.modes.length]
    //   }
    //   let modeLabels = {
    //     cases: "Total cases",
    //     casesState: "Relative no. of province cases across country",
    //     active: "Active cases",
    //     activeState: "Relative no. of active province cases across country",
    //     deaths: "Total deaths",
    //     deathsState: "Relative no. of province deaths across country",
    //     casesChange: "Active cases trend"
    //   }
    //   d3.select("#legend #header")
    //     .text(modeLabels[this.mode])
    //     .call(this.wrap, 180)
    //   let current = document.querySelector("#myRange").value
    //   this.setDayData(current)
    // },

    setRelativeStateLabels() {
      if (!this.currentStateName || !this.relativeToState) return

      let days = document.querySelector("#myRange").value
      let date = moment("2020-01-01")
        .add(days - 1, "days")
        .format("YYYY-MM-DD")
      let minMaxCases = mainData.getStateMinMax().filter(
        d => d.state === this.currentStateName && d.date <= date
      )
      minMaxCases = _.orderBy(minMaxCases, ["date"], ["desc"])[0]
      if (minMaxCases) {
        let highCases
        if (this.mode == "total") {
          highCases = minMaxCases.maxCases
        } else if (this.mode == "active") {
          highCases = minMaxCases.maxActiveCases
        } else if (this.mode == "deaths") {
          highCases = minMaxCases.maxDeaths
        } else if (this.mode == "trend") {
        }
        if (highCases) {
          d3.select("#lowCases").text(`${format(0)}`)
          d3.select("#highCases").text(`${format(highCases)}`)
        }
      }
    },
    setDayData: function(days) {
      if (!mainData.casesData) return
      
      let date = moment("2020-01-01").add(days - 1, "days")
      var desiredDate = date.format("YYYY-MM-DD")

      d3.select("#date").text(date.format("MMM D, YYYY"))
      // console.log(desiredDate)

      // let cases = this.getCasesOfDay(mainData.casesData, desiredDate)
      let cases = this.getSouthAfricaCasesOfDay(mainData.southAfricaCovidData, desiredDate)
      let stateCases = this.getStateCases(mainData.getStateMinMax(), desiredDate)

      let field = "casesRelativeToState"
      let colorFn = this.color2
      let lowText = null
      let highText = null

      if (this.relativeToState && this.level == 'county') {
        if (this.mode == "total") {
          colorFn = this.colorCases
          field = "casesRelativeToState"
        } else if (this.mode == "active") {
          colorFn = this.colorActiveCases
          field = "activeCasesRelativeToState"
        } else if (this.mode == "deaths") {
          colorFn = this.colorDeaths
          field = "deathsRelativeToState"
        } else if (this.mode == "trend") {
          colorFn = this.colorChange
          field = "difCasesPct"
        }
      } else {
        if (this.mode == "total") {
          colorFn = this.colorCases
          field = "casesRelativeToCountry"
          lowText = '0'
          highText = format(stateCases.maxCasesCountry)
        } else if (this.mode == "active") {
          colorFn = this.colorActiveCases
          field = "activeCasesRelativeToCountry"
          lowText = '0'
          highText = format(stateCases.maxDeathsCountry)
        } else if (this.mode == "deaths") {
          colorFn = this.colorDeaths
          field = "deathsRelativeToCountry"
          lowText = '0'
          highText = format(stateCases.maxActiveCasesCountry)
        } else if (this.mode == "trend") {
          colorFn = this.colorChange
          field = "difCasesPct"
        }
      }


      if (this.level == 'county' && !this.relativeToState) {
        if (this.mode == "total") {
          lowText = '0'
          highText = format(cases.maxCasesCountry)
        } else if (this.mode == "active") {
          lowText = '0'
          highText = format(cases.maxActiveCasesCountry)
        } else if (this.mode == "deaths") {
          lowText = '0'
          highText = format(cases.maxDeathsCountry)
        } else if (this.mode == "trend") {
        }
      } else if (this.level == 'county' && this.relativeToState) {
        if (this.currentStateName) {
          // If zoomed
          this.setRelativeStateLabels()
        } else if (this.mode == "total") {
          lowText = '0'
          highText = 'High cases'
        } else if (this.mode == "active") {
          lowText = '0'
          highText = 'High cases'
        } else if (this.mode == "deaths") {
          lowText = '0'
          highText = 'High deaths'
        } else if (this.mode == "trend") {
        }
      } else if (this.level == 'state') {
        if (this.mode == "total") {
          lowText = '0'
          highText = format(stateCases.maxCasesCountry)
        } else if (this.mode == "active") {
          lowText = '0'
          highText = format(stateCases.maxActiveCasesCountry)
        } else if (this.mode == "deaths") {
          lowText = '0'
          highText = format(stateCases.maxDeathsCountry)
        } else if (this.mode == "trend") {
        }
      }

      var colors = [
        colorFn(0),
        colorFn(0.04),
        colorFn(0.16),
        colorFn(0.36),
        colorFn(0.64),
        colorFn(1)
      ]
      if (this.mode == "trend") {
        colors = [
          colorFn(-1),
          colorFn(-0.5),
          colorFn(0.0),
          colorFn(0.5),
          colorFn(1)
        ]
        lowText = "Decreasing"
        highText = "Increasing"
      }

      if (lowText) {
        d3.select("#lowCases").text(lowText)
      }
      if (highText) {
        d3.select("#highCases").text(highText)
      }
      
      var grad = d3.select(".map-frame svg #grad")

      grad.selectAll("stop").remove()
      grad
        .selectAll("stop")
        .data(colors)
        .enter()
        .append("stop")
        .style("stop-color", function(d) {
          return d
        })
        .attr("offset", function(d, i) {
          return 100 * (i / (colors.length - 1)) + "%"
        })

      var colorCounty = id => {
        let record = cases.byCounty.get(id) || {}
        if (this.mode == "trend" && record.activeCases < 100) {
          return colorFn(0)
        }
        return colorFn(record[field] || 0)
      }
      var colorState = id => {
        let record = stateCases.byState.get(id) || {}
        if (this.mode == "trend" && record.activeCases < 100) {
          return colorFn(0)
        }
        return colorFn(record[field] || 0)
      }

      var mapTestSitesVisibility =
        days > 60 && testSitesShown ? "block" : "none"
      var mapClinicalVisibility =
        days > 60 && clinicalTrialsShown ? "block" : "none"
      d3.select("g#testSites").attr("display", mapTestSitesVisibility)
      mapClinicalTrials.attr("display", mapClinicalVisibility)

      if (this.level == "county") {
        mapCounties
          .transition()
          .duration(100)
          .attr("fill", d => colorCounty(d.properties.NAME_1.toLowerCase()))
        // mapStates
        //   .transition()
        //   .duration(100)
        //   .attr("fill", "#0000")
      } else if (this.level == "state") {
        mapStates
          .transition()
          .duration(100)
          .attr("fill", d => {
            return colorState(d.properties.name || d.properties.admin)
          })
      }
    },

    resizeToPath: function(d) {
      // let dateTime = Date.now()
      // console.log((Date.now() - dateTime)/1)
      let svg = d3.select("g#country")

      let width = viewBox.width
      let height = viewBox.height

      // if (d3.select(".background").node() === this) return reset()

      // console.log((Date.now() - dateTime)/1)

      var bounds = path.bounds(d),
        dx = bounds[1][0] - bounds[0][0],
        dy = bounds[1][1] - bounds[0][1],
        x = (bounds[0][0] + bounds[1][0]) / 2,
        y = (bounds[0][1] + bounds[1][1]) / 2,
        scale = 0.9 / Math.max(dx / width, dy / height),
        translate = [-scale * x + width / 2, - scale * y + height / 2]
        // translate = [-1665 -scale * x + width / 2, +1000 - scale * y + height / 2]

      const mainSvg = d3.select(".map-frame svg")
      mainSvg
        .transition()
        // .ease('easeLinear')
        .duration(750)
        .call(
          zoom.transform,
          d3.zoomIdentity.translate(translate[0], translate[1]).scale(scale),
          // d3.mouse(svg.node())
          null
        )
    },

    countyClicked: function(d) {
      let name = d.properties.NAME_1
      this.currentCountyId = d.properties.NAME_1
      this.currentStateName = null
      this.setBreadcrumb("county", d.properties.province, d.properties.country)

      this.logAction(`CountyClicked (${name})`)
      this.showBar(
        `Click here to be notified when reopening mandates change on ${name}.`,
        `Scroll down to see province profile: cases, mandates, test sites and clinical trials.`
      )

      this.resizeToPath(d)

      this.profilePanel = 1
      setTimeout(() => this.displayCountyProfile(name, d.properties.NAME_1 ,d.properties.country))

      d3.select("#resetBtn").style("display", "block")
      d3.select("#zoomOutBtn").style("display", "inline-block")
      this.showHint = false
    },

    zoomToState: function(name) {
      let d = mainData.states.find(s => s.properties.name === name || s.properties.admin == name)
      let paths = d3
        .select("g#states")
        .selectAll("path")
        .nodes()
      let index = mainData.states.indexOf(d)

      this.stateClicked(d, index, paths)
    },

    stateClicked: function(d, index, paths) {
      this.level = 'state'
      let stateName = d.properties.name || d.properties.admin
      this.currentStateName = stateName
      this.currentCounty = null
      this.logAction(`StateClicked (${stateName})`)
      this.showBar(
        `Click here to be notified when reopening mandates change on ${stateName}.`,
        `Scroll down to see country profile: cases, reopenings and closings`
      )

      this.setBreadcrumb("state", stateName)

      let dateTime = Date.now()
      this.resizeToPath(d)

      this.setRelativeStateLabels()
      d3.select("#legendTitle").text(`${stateName}`)

      // // Resize Legend
      // const legend = d3
      //   .select("#legend")
      //   .transition()
      //   .duration(750)
      //   .attr("transform", "translate(723,20)scale(0.8)")
      // d3.select("#legend #frame")
      //   .transition()
      //   .duration(750)
      //   .attr("height", 200 + 313 / 0.8)
      // d3.select("#legend #reopening").style("display", "block")

      // let stateReopeningData = this.getStateReopeningData(stateName)

      // let reopeningScheme = [
      //   { valueField: "publicOpenPlaygrounds", display: "Playgrounds" },
      //   { valueField: "publicOpenStateParks", display: "State Parks" },
      //   { valueField: "publicOpenParkFacilities", display: "Park Facilities" },
      //   { valueField: "publicOpenBeaches", display: "Beaches" },
      //   { valueField: "publicOpenBoating", display: "Boating" },
      //   {
      //     valueField: "publicOpenHuntingFishing",
      //     display: "Hunting / Fishing"
      //   },
      //   { valueField: "publicOpenCampgrounds", display: "Campgrounds" },
      //   { valueField: "publicOpenTennisCourts", display: "Tennis Courts" },
      //   { valueField: "publicOpenGolfCourses", display: "Golf Courses" }
      // ]

      // let reopenings = reopeningScheme.map(s => {
      //   let value = {
      //     display: s.display
      //   }
      //   let status = stateReopeningData[s.valueField] || "Unknown"
      //   status = status.toLowerCase()
      //   if (["open", "closed"].indexOf(status) != -1) {
      //     value.status = status
      //   } else {
      //     value.status = ""
      //   }
      //   value.statusColor =
      //     [green, red][["open", "closed"].indexOf(value.status)] || gray
      //   return value
      // })
      // d3.select("#legend #reopening")
      //   .selectAll("g")
      //   .remove()
      // let reopeningRows = d3
      //   .select("#legend #reopening")
      //   .selectAll("g")
      //   .data(reopenings)
      //   .enter()
      //   .append("g")
      // reopeningRows
      //   .append("circle")
      //   .attr("cx", 20)
      //   .attr("cy", (d, ix) => 50 + 30 * ix)
      //   .attr("r", 6)
      //   .style("fill", d => d.statusColor)
      // reopeningRows
      //   .append("text")
      //   .attr("x", 30)
      //   .attr("y", (d, ix) => 50 + 30 * ix + 2)
      //   .text(d => d.display)
      //   .style("font-size", "15px")
      //   .attr("alignment-baseline", "middle")

      // let tsNum = testSites.filter(s => this.toLowerTrimmed(s.State) == this.toLowerTrimmed(stateName)).length
      let tsNum = mainData.testSites2.filter(
        s => this.toLowerTrimmed(s.stateName) == this.toLowerTrimmed(stateName)
      ).length
      d3.select("#legendTestSites")
        .select("text")
        .text(`Test Sites (${tsNum})`)
      let ctNum = mainData.clinicalTrials.filter(s => s.State == stateName).length
      d3.select("#legendClinicalTrials")
        .select("text")
        .text(`Clinical Trials (${ctNum})`)

      this.profilePanel = 0
      setTimeout(() => this.displayStateProfile(stateName))

      // permit choosing county
      // d3.selectAll("g#states path").attr("fill", "#0000")
      if (stateName == "South Africa") {
        d3.select(paths[index]).attr("fill", "none")
      }
      d3.select("#resetBtn").style("display", "block")
      d3.select("#zoomOutBtn").style("display", "inline-block")
      this.showHint = false
    },

    displayStateProfile: function(state) {
      let profile = d3.select(".state-profile")
      profile.style("display", "block")
      profile.select(".name").text(state)

      // Display Total Cases
      let days = document.querySelector("#myRange").value
      let date = moment("2020-01-01")
        .add(days - 1, "days")
        .format("YYYY-MM-DD")
      let stateSummary = mainData.getStateMinMax().filter(
        d => d.state === state && d.date <= date
      )
      stateSummary = _.orderBy(stateSummary, ["date"], ["desc"])[0]
      if (stateSummary) {
        profile.select(".cases-icon").style("background", this.color2(1))
        profile.select(".cases").text(`${format(stateSummary.total)} cases`)
      } else {
        profile.select(".cases").text(`NA cases`)
      }

      this.updateStateCasesChart(state)
      this.updateReopeningStatusChart(state)

      let stateReopeningData = this.getStateReopeningData(state)

      let that = this
      $("[id^=field-]").text(function() {
        let id = $(this).attr("id")
        id = id.substring(id.indexOf("-") + 1)
        let value = stateReopeningData[id]

        if (value == "N/A") {
          $(this).text("-")
        } else if (value) {
          if (id.endsWith("Occupacy") && +value <= 1 && +value >= 0) {
            value = `${Math.round(value * 100)}%`
          }
          $(this).text(value)

          // Add class for permitted, recommended, ...
          let highlightedValues = [
            "prohibited",
            "permitted",
            "required",
            "recommended",
            "not-required",
            "not-permitted",
            "yes",
            "no"
          ]
          let classVal = that.toLowerTrimmed(value).replace(/ /g, "-")
          highlightedValues.forEach(val =>
            $(this).removeClass("highlight-" + val)
          )
          if (highlightedValues.indexOf(classVal) != -1) {
            $(this).addClass("highlight-" + classVal)
          } else if (
            that.toLowerTrimmed(value).indexOf("recommended") != -1 &&
            value.length <= 60
          ) {
            $(this).addClass("highlight-recommended")
          } else if (
            that.toLowerTrimmed(value).indexOf("required") != -1 &&
            value.length <= 60
          ) {
            $(this).addClass("highlight-required")
          }
        } else {
          $(this).text("")
        }
      })

      this.toLowerTrimmed(stateReopeningData["gatheringOpen"]) ==
      "not permitted"
        ? $("#special-gatheringOpen").show()
        : $("#special-gatheringOpen").hide()
      this.toLowerTrimmed(stateReopeningData["medicalOpen"]) == "not permitted"
        ? $("#special-medicalOpen").show()
        : $("#special-medicalOpen").hide()
      this.toLowerTrimmed(stateReopeningData["schoolsOpen"]) == "closed"
        ? $("#special-schoolsOpen").show()
        : $("#special-schoolsOpen").hide()
      this.toLowerTrimmed(stateReopeningData["childcareOpen"]) == "closed"
        ? $("#special-childcareOpen").show()
        : $("#special-childcareOpen").hide()

      // TODO: support multiple classes
      // $("a[class^=link-]")
      let linkElements = $("a[class^=link-]").filter(function() {
        return $(this)
          .attr("class")
          .split(/\s+/)
          .some(c => c.startsWith("link-"))
      })
      linkElements.text(function() {
        let field = $(this)
          .attr("class")
          .split(/\s+/)
          .find(c => c.startsWith("link-"))
        field = field.substring(field.indexOf("-") + 1)
        if (stateReopeningData[field]) {
          $(this).attr("href", stateReopeningData[field])
        } else {
          $(this).attr("href", "")
        }
      })

      $("[id^=openClose-]").text(function() {
        let id = $(this).attr("id")
        id = id.substring(id.indexOf("-") + 1)
        let status = stateReopeningData[id] || "Unknown"
        status = status.toLowerCase()
        $(this).removeClass("open")
        $(this).removeClass("closed")
        if (["open", "closed"].indexOf(status) != -1) {
          $(this).addClass(status)
        }
      })

      // Hide / show sections
      $(".fieldHideable").each(function() {
        let fields = $(this)
          .find("[id^=field-]")
          .map(function() {
            return $(this).text()
          })
          .get()
          .filter(t => !!t && t != "-")
        let openClose = $(this)
          .find("[id^=openClose-]")
          .map(function() {
            return $(this).hasClass("open") || $(this).hasClass("closed")
          })
          .get()
          .filter(t => !!t)
        let links = $(this)
          .find("a[class^=link-]")
          .map(function() {
            return $(this).attr("href")
          })
          .get()
          .filter(t => !!t)
        if (fields.length || openClose.length || links.length) {
          $(this).show()
        } else {
          $(this).hide()
        }
      })

      // Display
      this.profile.showProfile = true
      this.profile.showState = true
      this.profile.showCounty = false
      this.profile.showTestSites = false
      this.profile.showClinicalTrials = false
      // d3.select(".accordion").style("display", "block")
      // d3.select(".county-profile").style("display", "none")
      // d3.select(".test-site-profile").style("display", "none")
      // d3.select(".trial-site-profile").style("display", "none")

      // Collapse
      // $(".accordion #collapseState").collapse("show")
    },

    updateStateCasesChart: function(stateName) {
      // Filter and transform data

      let processCases = (casesData) => {

        let groupedByDate = _.groupBy(
          casesData,
          "date"
        )

        let casesDates = casesData
          .map(d => d.date)
          .sort()
        let stopDate = moment(casesDates[casesDates.length - 1])
        var dateArray = []
        var currentDate = moment("2020-02-26")
        while (currentDate.isSameOrBefore(stopDate)) {
          dateArray.push(currentDate.format("YYYY-MM-DD"))
          currentDate = currentDate.add(1, "days")
        }

        let casesByDate = _.map(dateArray, date => {
          let arr = groupedByDate[date] || []
          return {
            date: date,
            cases: arr.map(d => +d.cases).reduce(sum, 0),
            deaths: arr.map(d => +d.cases).reduce(sum, 0)
          }
        })
        casesByDate = _.orderBy(casesByDate, ["date"], ["asc"]).filter(
          d => d.date >= "2020-02-26"
        )
        let pastCases = 0
        let pastDeaths = 0
        let pastNCases = []
        let dayAverage = 7
        let minCases = 0
        let firstIxOverMin = -1

        casesByDate.forEach((d, ix) => {
          if (firstIxOverMin === -1 && +d.cases >= minCases) {
            firstIxOverMin = ix
          }
          d.newCases = d.cases - pastCases
          d.newDeaths = d.deaths - pastDeaths

          pastNCases.push(d.newCases)
          pastNCases = pastNCases.splice(
            Math.max(0, pastNCases.length - dayAverage),
            dayAverage
          )
          d.average = pastNCases.reduce(sum, 0) / pastNCases.length

          pastCases = d.cases
          pastDeaths = d.deaths
        })
        casesByDate.splice(0, firstIxOverMin)

        let data = casesByDate.map(d => ({
          date: this.timeParse(d.date),
          newCases: d.newCases,
          average: d.average
        }))

        return data
      }
      
      let data = processCases(mainData.casesData.filter(d => d.state == stateName))
      // let comparisonMap = {
      //   'South Africa': 'Texas',
      //   'Rwanda': 'New Jersey',
      //   'Ghana': 'Florida',
      //   'Nigeria': 'South Dakota',
      //   'Kenya': 'Illinois',
      // }
      // let comparedState = comparisonMap[stateName] || 'New Jersey'
      // console.log({ currentState: stateName})
      // console.log({ comparedState: comparedState})
      // let comparedData = processCases(mainData.nytcasesData.filter(d => d.state == 'New Jersey'))
      let comparedData = []

      var margin = { top: 20, right: 20, bottom: 30, left: 90 },
        width = 850 - margin.left - margin.right,
        height = 200 - margin.top - margin.bottom

      // Set the ranges
      var x = d3
        .scaleBand()
        .range([0, width])
        .paddingInner(0.1)
        .paddingOuter(1)
      var y = d3.scaleLinear().range([height, 0])

      // Scale the range of the data in the domains
      x.domain(data.map(d => d.date))
      y.domain([
        0,
        d3.max(data, function(d) {
          return d.newCases
        })
      ])

      // Create svg
      d3.select("#stateCasesChart svg").remove()
      var svg = d3
        .select("#stateCasesChart")
        .append("svg")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .style("width", "100%")
        .attr(
          "viewBox",
          `0 0 ${width + margin.left + margin.right} ${height +
            margin.top +
            margin.bottom}`
        )
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")")

      // Define tooltip
      d3.select("#stateCasesChart .tooltip-label")
      var tooltip = d3
        .select("#stateCasesChart")
        .append("div")
        .attr("class", "tooltip-label")
        .style("opacity", 0)

      let showTooltip = function(html) {
        let chartRect = d3
          .select("#stateCasesChart")
          .node()
          .getBoundingClientRect()
        tooltip
          .transition()
          .duration(200)
          .style("opacity", 0.93)
        tooltip
          .html(html)
          .style("left", d3.event.clientX - chartRect.x + "px")
          .style("top", d3.event.clientY - chartRect.y - 28 + "px")
      }

      let hideTooltip = function() {
        tooltip
          .transition()
          .duration(500)
          .style("opacity", 0)
      }

      // Add the x Axis
      let xAxis = d3
        .axisBottom()
        .scale(x)
        .tickFormat(d3.timeFormat("%b %d"))
        .ticks(d3.timeMonth.every(14))
        // .tickSizeOuter([100])
      svg
        .append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + height + ")")
        .call(xAxis)
        .selectAll("text")
        .attr("transform", "translate(0,-3)rotate(315)")
        // .attr("transform", "translate(0,-3px)rotate(315)")
        .style("text-anchor", "end")

      // Add the y Axis
      svg.append("g").call(d3.axisLeft(y))

      // Add bar cases
      svg
        .append("g")
        .selectAll(".bar")
        .data(comparedData)
        .enter()
        .append("rect")
        .attr("fill", casesComparedColor)
        .attr("class", "bar")
        .style("opacity", 0.5)
        .attr("x", function(d) {
          return x(d.date)
        })
        .attr("width", x.bandwidth())
        .attr("y", function(d) {
          return y(d.newCases*2)
        })
        .attr("height", function(d) {
          return height - y(d.newCases*2)
        })
        .on("mouseover", function(d) {
          // d3.select(this).attr("fill", casesComparedColorHover)
          showTooltip(
            `<b>${d3.timeFormat("%b %d")(d.date)}</b><br>${format(
              d.newCases
            )} cases`
          )
        })
        .on("mouseout", function(d) {
          // d3.select(this).attr("fill", casesColor)
          hideTooltip()
        })

      // Add bar cases
      svg
        .append("g")
        .selectAll(".bar")
        .data(data)
        .enter()
        .append("rect")
        .attr("fill", casesColor)
        .attr("class", "bar")
        .style("opacity", 0.75)
        .attr("x", function(d) {
          return x(d.date)
        })
        .attr("width", x.bandwidth())
        .attr("y", function(d) {
          return y(d.newCases)
        })
        .attr("height", function(d) {
          return height - y(d.newCases)
        })
        .on("mouseover", function(d) {
          d3.select(this).attr("fill", casesColorHover)
          showTooltip(
            `<b>${d3.timeFormat("%b %d")(d.date)}</b><br>${format(
              d.newCases
            )} cases`
          )
        })
        .on("mouseout", function(d) {
          d3.select(this).attr("fill", casesColor)
          hideTooltip()
        })


      // Add line average
      var line = d3
        .line()
        .x(function(d, i) {
          return x(d.date)
        })
        .y(function(d) {
          return y(d.average)
        })
        .curve(d3.curveMonotoneX) // apply smoothing to the line
      let lineG = svg.append("g")
      lineG
        .append("path")
        .datum(data)
        .attr("class", "line")
        .attr("fill", "none")
        .attr("stroke", lineColor)
        .attr("stroke-width", "3")
        .attr("d", line)

      // Add dots on average
      lineG
        .selectAll(".dot")
        .data(data)
        .enter()
        .append("circle")
        .attr("class", "dot")
        .attr("fill", lineColor)
        .attr("cx", function(d, i) {
          return x(d.date)
        })
        .attr("cy", function(d) {
          return y(d.average)
        })
        .attr("r", 3)
        .on("mouseover", function(d) {
          d3.select(this)
            .attr("fill", dotColorHover)
            .raise()
          showTooltip(
            `<b>${d3.timeFormat("%b %d")(d.date)}</b><br>${formatNoDecimal(
              d.average
            )} cases (7-day average)`
          )
        })
        .on("mouseout", function() {
          d3.select(this)
            .attr("fill", lineColor)
            .raise()
          hideTooltip()
        })
    },

    toggleTestSites: function() {
      testSitesShown = !testSitesShown
      var display = testSitesShown ? "block" : "none"
      var opacity = testSitesShown ? "1" : "0.5"
      d3.select("g#testSites").attr("display", display)
      d3.select("#legendTestSites").style("opacity", opacity)
      d3.select("#toggleTestSites").classed("on", testSitesShown)
      d3.select("#resetBtn").style("display", "block")
    },

    toggleClinicalTrials: function() {
      clinicalTrialsShown = !clinicalTrialsShown
      var display = clinicalTrialsShown ? "block" : "none"
      var opacity = clinicalTrialsShown ? "1" : "0.5"
      mapClinicalTrials.attr("display", display)
      d3.select("#legendClinicalTrials").style("opacity", opacity)
      d3.select("#toggleClinicalTrials").classed("on", clinicalTrialsShown)
      d3.select("#resetBtn").style("display", "block")
    },

    setBreadcrumb: function(part, name, countryName) {
      if (part == "state") {
        d3.select("#bc-state a")
          .attr("href", `javascript:zoomToState('${name}')`)
          .text(name)
        d3.select(".bc #bc-map").style("display", "block")
        d3.select(".bc #bc-state").style("display", "block")
        d3.select(".bc #bc-county").style("display", "none")
      }
      if (part == "county") {
        d3.select("#bc-state a").text("")
        d3.select(".bc .county").remove()
        let stateName = ""
        if (countryName) {
          stateName = countryName
        } else if (name.indexOf(",")) {
          stateName = name.split(",")[1].trim()
          name = name.split(",")[0].trim()
        }
        d3.select("#bc-state a")
          .attr("href", `javascript:zoomToState('${stateName}')`)
          .text(stateName)
        d3.select("#bc-county a").text(name)
        d3.select(".bc #bc-map").style("display", "block")
        d3.select(".bc #bc-state").style("display", "block")
        d3.select(".bc #bc-county").style("display", "block")
      }

      if (part == "map") {
        d3.select(".bc #bc-map").style("display", "none")
        d3.select(".bc #bc-state").style("display", "none")
        d3.select(".bc #bc-county").style("display", "none")
      }
    },

    animatemap: function() {
      this.logAction("AnimateMap")

      if (timeoutId) {
        clearTimeout(timeoutId)
        timeoutId = null
        d3.select(".play-btn .material-icons").text("play_arrow")
        return
      }

      d3.select(".play-btn .material-icons").text("pause")

      let min = 21 // Start Jan-21
      let current = document.querySelector("#myRange").value
      current = Math.max(current, min)
      let max = moment().diff('2019-12-31', 'days')
      if (current == max) {
        current = min
      }

      let that = this
      function tick() {
        document.querySelector("#myRange").value = current
        that.setDayData(current)

        if (current < max) {
          current++
          timeoutId = setTimeout(tick, 50)
        } else {
          d3.select(".play-btn .material-icons").text("play_arrow")
          clearTimeout(timeoutId)
          timeoutId = null
        }
      }

      tick()
    },

    // Groups array by a property
    // Usage: groupBy(['one', 'two', 'three'], 'length')
    // Result: {3: ["one", "two"], 5: ["three"]}
    groupBy: function(xs, key) {
      return xs.reduce(function(rv, x) {
        ;(rv[x[key]] = rv[x[key]] || []).push(x)
        return rv
      }, {})
    },

    scrollMeTo(selector) {
      var element = $(selector).get(0);
      var top = element.offsetTop;

      window.scrollTo(0, top);
    },

    showBar(message, message2) {
      // if (this.notScrolled && message2) {
      //   this.$emit('showProfileHint', message2)
      // }
      // else 
      if (message) {
        this.$emit('showProfileHint', message)
      }
    },

    initCombosAndActions: function() {
      this.logAction("Visit")


      let stateNames = _.uniq(mainData.casesData.map(d => d.state))
      stateNames.sort()

      // d3.select("#stateCombo")
      //   .selectAll("option.state")
      //   .data(stateNames)
      //   .enter()
      //   .append("option")
      //   .attr("class", "state")
      //   .text(d => d)

      let that = this
      $(".profiles").on("click", ".test-sites-toggles .criteria-toggle", function(event) {
        console.log("criteria-toggle")
        if ($(this).hasClass("selected")) {
          $(this).removeClass("selected")
        } else {
          $(this).addClass("selected")
        }

        that.updateTestSitesTable()
      })

      $(".profiles").on("click", "#testSitesTable .criteria-toggle-header", function(
        event
      ) {
        let criteriaToggleName = "." + $(this).data("criteria-toggle")
        if ($(criteriaToggleName).hasClass("selected")) {
          $(criteriaToggleName).removeClass("selected")
        } else {
          $(criteriaToggleName).addClass("selected")
        }

        that.updateTestSitesTable()
      })
      
      $(".profiles").on("click", ".criteria-trials-toggles .criteria-toggle", function(event) {
        console.log("criteria-toggle")
        if ($(this).hasClass("selected")) {
          $(this).removeClass("selected")
        } else {
          $(this).addClass("selected")
        }

        that.updateClinicalTrialsTable()
      })

      $(".profiles").on("click", "#clinicalTrialsTable .criteria-toggle-header", function(
        event
      ) {
        let criteriaToggleName = "." + $(this).data("criteria-toggle")
        if ($(criteriaToggleName).hasClass("selected")) {
          $(criteriaToggleName).removeClass("selected")
        } else {
          $(criteriaToggleName).addClass("selected")
        }

        that.updateClinicalTrialsTable()
      })

    },

    // stateComboChanged: function() {
    //   document.querySelector("#countyCombo").value = 0

    //   let state = document.querySelector("#stateCombo").value
    //   let countyNames = _.uniq(
    //     mainData.casesData.filter(d => d.state == state).map(d => d.county)
    //   )
    //   countyNames.sort()

    //   d3.select("#countyCombo")
    //     .selectAll("option.county")
    //     .remove()
    //   d3.select("#countyCombo")
    //     .selectAll("option.county")
    //     .data(countyNames)
    //     .enter()
    //     .append("option")
    //     .attr("class", "county")
    //     .text(d => d)

    //   this.profilePanel = 0
    //   this.setTimeout(() => this.displayStateProfile(stateName))
    // },

    // countyComboChanged: function() {
    //   console.log("countyComboChanged")
    //   let state = document.querySelector("#stateCombo").value
    //   let county = document.querySelector("#countyCombo").value

    //   let countyData = mainData.casesData.find(
    //     d => d.state == state && d.county == county
    //   )

    //   if (mainData.counties) {
    //     this.profilePanel = 1
    //     setTimeout(() => this.displayCountyProfile(countyData.fullName, countyData.location))
    //   }
    // },

    mobileCheck: function() {
      let check = false
      ;(function(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true
      })(navigator.userAgent || navigator.vendor || window.opera)
      return check
    },

    getOS: function() {
      var osName = "Unknown OS"
      if (navigator.userAgent.indexOf("Win") != -1) osName = "Windows"
      if (navigator.userAgent.indexOf("Mac") != -1) osName = "Macintosh"
      if (navigator.userAgent.indexOf("Linux") != -1) osName = "Linux"
      if (navigator.userAgent.indexOf("Android") != -1) osName = "Android"
      if (navigator.userAgent.indexOf("like Mac") != -1) osName = "iOS"

      return osName
    },

    getBrowserDetails: function() {
      // https://stackoverflow.com/a/11219680
      // var nVer = navigator.appVersion;
      var nAgt = navigator.userAgent
      var browserName = navigator.appName
      var fullVersion = "" + parseFloat(navigator.appVersion)
      var majorVersion = parseInt(navigator.appVersion, 10)
      var nameOffset, verOffset, ix

      // In Opera, the true version is after "Opera" or after "Version"
      if ((verOffset = nAgt.indexOf("Opera")) != -1) {
        browserName = "Opera"
        fullVersion = nAgt.substring(verOffset + 6)
        if ((verOffset = nAgt.indexOf("Version")) != -1)
          fullVersion = nAgt.substring(verOffset + 8)
      }
      // In MSIE, the true version is after "MSIE" in userAgent
      else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
        browserName = "Microsoft Internet Explorer"
        fullVersion = nAgt.substring(verOffset + 5)
      }
      // In Chrome, the true version is after "Chrome"
      else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
        browserName = "Chrome"
        fullVersion = nAgt.substring(verOffset + 7)
      }
      // In Safari, the true version is after "Safari" or after "Version"
      else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
        browserName = "Safari"
        fullVersion = nAgt.substring(verOffset + 7)
        if ((verOffset = nAgt.indexOf("Version")) != -1)
          fullVersion = nAgt.substring(verOffset + 8)
      }
      // In Firefox, the true version is after "Firefox"
      else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
        browserName = "Firefox"
        fullVersion = nAgt.substring(verOffset + 8)
      }
      // In most other browsers, "name/version" is at the end of userAgent
      else if (
        (nameOffset = nAgt.lastIndexOf(" ") + 1) <
        (verOffset = nAgt.lastIndexOf("/"))
      ) {
        browserName = nAgt.substring(nameOffset, verOffset)
        fullVersion = nAgt.substring(verOffset + 1)
        if (browserName.toLowerCase() == browserName.toUpperCase()) {
          browserName = navigator.appName
        }
      }
      // trim the fullVersion string at semicolon/space if present
      if ((ix = fullVersion.indexOf(";")) != -1)
        fullVersion = fullVersion.substring(0, ix)
      if ((ix = fullVersion.indexOf(" ")) != -1)
        fullVersion = fullVersion.substring(0, ix)

      majorVersion = parseInt("" + fullVersion, 10)
      if (isNaN(majorVersion)) {
        fullVersion = "" + parseFloat(navigator.appVersion)
        majorVersion = parseInt(navigator.appVersion, 10)
      }

      return {
        browserName,
        fullVersion,
        majorVersion,
        appName: navigator.appName,
        userAgent: navigator.userAgent
      }
    },

    logAction: function(section) {
      console.log(section)

      let browserDetails = this.getBrowserDetails()

      let details = {
        section,
        iPAddress: this.ip,
        platform: this.getOS(),
        browser: browserDetails.browserName,
        browserVersion: browserDetails.fullVersion,
        userAgent: browserDetails.userAgent,
        isMobile: this.mobileCheck(),
        url: "www.millionpatientscured.com"
      }
      fetch(
        "https://testsites.millionpatientscured.com:5000/api/siteActionLog",
        {
          // fetch('http://localhost:5000/api/siteActionLog', {
          method: "post",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(details)
        }
      )
        .then(() => {
          console.log("success logging")
        })
        .catch(function(error) {
          console.error("error logging")
          console.error(error)
        })
    },

    init: async function() {


      let promises = []
      let topology = null
      let stateTopology = null
      let southAfricaTopology = null

      let namesPromise = (async function(d3) {
        const {
          locations: { flat }
        } = await d3.json(
          "https://gist.githubusercontent.com/mbostock/df1b792d76fcb748056ff94b912e4bb8/raw/b1da4894cfb1e56a24129c27b39aa957d7f0c165/names.json"
        )
        const map = new Map(
          Array.from(flat, ({ location_id, name }) => [location_id, name])
        )
        for (const { location_id, parent_id, level, name } of flat) {
          if (level === 2) {
            map.set(location_id, `${name}, ${map.get(parent_id)}`)
          }
        }
        return map
      })(d3)

      namesPromise.then(res => (mainData.names = res))
        .catch(console.log)

      promises.push(namesPromise)

      this.ip = "unknown"
      d3.json("https://api.ipify.org?format=json").then(
        res => (this.ip = res.ip)
      ).catch(console.log)

      promises.push(
        d3
          .json(
            "https://gist.githubusercontent.com/mbostock/df1b792d76fcb748056ff94b912e4bb8/raw/b1da4894cfb1e56a24129c27b39aa957d7f0c165/topology.json"
          )
          .then(res => (topology = res.topology))
          .catch(console.log)
      )
      promises.push(
        d3
          // .json("https://bl.ocks.org/bricedev/raw/3905007f1794b0cb0bcd/ad5c995f6990f7c3c7fad5c6206bc6fd5462f1fb/africa.json")
          // .json("africa.json")
          .json("countries-110m.json")
          //.json("countries-10m.json")
          // .json("states-albers-10m.json")
          .then(res => (stateTopology = res))
          .catch(console.log)
      )
      promises.push(
        d3
          // .json("https://bl.ocks.org/bricedev/raw/3905007f1794b0cb0bcd/ad5c995f6990f7c3c7fad5c6206bc6fd5462f1fb/africa.json")
          // .json("africa.json")
          .json("south-africa-provinces.json")
          //.json("countries-10m.json")
          // .json("states-albers-10m.json")
          .then(res => (southAfricaTopology = res))
          .catch(console.log)
      )
      // let clinicalTrialsJson =
      //   "https://gist.githubusercontent.com/enriquecarro/51185bef0510ed7037fc09eeff8fd667/raw/clinical-trials.json"
      // promises.push(
      //   d3
      //     // .json(clinicalTrialsJson)
      //     .json("clinical-trials.json")
      //     .then(res => (mainData.clinicalTrials = res.clinicalTrials))
      //     .catch(console.log)
      // )
      // promises.push(
      //   d3.csv("testing-locations.csv")
      //     .then(res => (mainData.testSites2 = res))
      //     .catch(console.log)
      // )
      mainData.testSites2 = []
      mainData.clinicalTrials = []
      let reopeningDataJson = "reopening-data-africa.json?v=10"
      promises.push(
        d3.json(reopeningDataJson)
          .then(res => (mainData.reopeningData = res))
          .catch(console.log)
      )
      // promises.push(
      //   d3
      //     .csv(
      //       "https://raw.githubusercontent.com/nytimes/covid-19-data/master/us-counties.csv"
      //     )
      //     .then(res => (mainData.nytcasesData = res))
      //     .catch(console.log)
      // )
      
      // function excelDateToString(excel_date, time = false) {
      //   let day_time = excel_date % 1
      //   let meridiem = "AMPM"
      //   let hour = Math.floor(day_time * 24)
      //   let minute = Math.floor(Math.abs(day_time * 24 * 60) % 60)
      //   let second = Math.floor(Math.abs(day_time * 24 * 60 * 60) % 60)
      //   hour >= 12 ? meridiem = meridiem.slice(2, 4) : meridiem = meridiem.slice(0, 2)
      //   hour > 12 ? hour = hour - 12 : hour = hour
      //   hour = hour < 10 ? "0" + hour : hour
      //   minute = minute < 10 ? "0" + minute : minute
      //   second = second < 10 ? "0" + second : second
      //   let daytime = "" + hour + ":" + minute + ":" + second + " " + meridiem
      //   let jsDate = time ? daytime : (new Date(0, 0, excel_date, 0, -new Date(0).getTimezoneOffset(), 0)).toLocaleDateString() + " " + daytime

      //   return moment(jsDate).format("YYYY-MM-DD")
      // }

      // https://data.humdata.org/dataset/coronavirus-covid-19-cases-and-deaths/resource/2ac6c3c0-76fa-4486-9ad0-9aa9e253b78d
      promises.push(
        d3
          .csv(
            "WHO-COVID-19-global-data.csv"
            // "https://covid19.who.int/WHO-COVID-19-global-data.csv"
          )
          .then(res => {
            let data = res
            data = data.map(d => ({
              date: d["Date_reported"], 
              // county: d["Country"], 
              county: "Country",
              state: d["Country"],
              cases: d["Cumulative_cases"],
              deaths: d["Cumulative_deaths"]
              	//  Country_code	 Country	 WHO_region	 New_cases	 	 New_deaths	 

            }))
            mainData.casesData = data
          })
          .catch(console.log)
      )
      
      promises.push(
        d3.csv("south-africa-covid-data.csv")
          .then(data => {
            let headers = _.map(data[0], (v, k) => k).filter(k => k != "Specimen received date")
            console.log("south-africa-covid-data.csv")
            console.log(headers)

            data = headers.map(h => 
              data.map(d => {
                return ({
                  county: h,
                  date: moment(d["Specimen received date"]).format("YYYY-MM-DD"),
                  cases: +d[h]
                })
              })).flat()

            console.log(data)
            mainData.southAfricaCovidData = data
          })
          .catch(console.log)
      )
      await Promise.all(promises)
      // this.loading = false
      let dateTime = Date.now()

      // stateTopology.transform.scale = [
      //   0.008356007371183138,
      //   0.004884379357258422
      // ]
      // stateTopology.transform.translate = [
      //   31.287342740802387,
      //   9.642076412917277
      // ]
      stateTopology.bbox = [
        31.287342740802387,
        9.642076412917277,
        866.5765425854045,
        496.7312983451869
      ]

      let africaCountries = ["Angola", "Burundi", "Benin", "Burkina Faso", "Botswana", "Central African Republic", "Ivory Coast", "Cameroon", "Democratic Republic of the Congo", "Republic of Congo", "Comoros", "Cape Verde", "Djibouti", "Algeria", "Egypt", "Eritrea", "Ethiopia", "Gabon", "Ghana", "Guinea", "Gambia", "Guinea Bissau", "Equatorial Guinea", "Kenya", "Liberia", "Libya", "Lesotho", "Morocco", "Madagascar", "Mali", "Mozambique", "Mauritania", "Malawi", "Namibia", "Niger", "Nigeria", "Rwanda", "Western Sahara", "Sudan", "South Sudan", "Senegal", "Sierra Leone", "Somaliland", "Somalia", "Sao Tome and Principe", "Swaziland", "Chad", "Togo", "Tunisia", "United Republic of Tanzania", "Uganda", "South Africa", "Zambia", "Zimbabwe"]
      africaCountries.push(...["Dem. Rep. Congo", "W. Sahara", "Côte d'Ivoire", "Tanzania", "Guinea-Bissau", "Lesotho", "S. Sudan", "Central African Rep.", "Congo", "eSwatini", "Eq. Guinea"])
      
      stateTopology.objects.countries.geometries = stateTopology.objects.countries.geometries
        .filter(d => africaCountries.includes(d.properties.name))
      // debugger
      mainData.casesData = mainData.casesData.filter(d => africaCountries.includes(d.state))

      let mapNames = {
        "Dem. Rep. Congo": "Democratic Republic of the Congo",
        "W. Sahara": "Western Sahara",
        "Côte d'Ivoire": "Ivory Coast",
        "Tanzania": "United Republic of Tanzania",
        "Guinea-Bissau": "Guinea Bissau",
        "Lesotho": "Lesotho",
        "S. Sudan": "South Sudan",
        "Central African Rep.": "Central African Republic",
        "Congo": "Republic of Congo",
        "eSwatini": "eSwatini",
        "Eq. Guinea": "Equatorial Guinea"
      }
      stateTopology.objects.countries.geometries.forEach(d => {
        let name = mapNames[d.properties.name]
        if (name) {
          d.properties.name = name
        }
      })

      mainData.states = topojson.feature(
        stateTopology,
        stateTopology.objects.countries
      ).features
      mainData.southAfricaProvinces = topojson.feature(
        southAfricaTopology,
        southAfricaTopology.objects.ZAF_adm1
      ).features
      mainData.southAfricaProvinces.forEach(d => {
        // TODO: standarize: use location_id or not, use others ?
        d.properties.location_id = d.properties.NAME_1
        d.properties.province = d.properties.NAME_1
        d.properties.country = "South Africa"
      })
      console.log(mainData.states)
      console.log("mainData.southAfricaProvinces")
      console.log(mainData.southAfricaProvinces)
      // mainData.counties = topojson.feature(
      //   topology,
      //   topology.objects.counties
      // ).features
      
      console.log((Date.now() - dateTime)/1)
      dateTime = Date.now()

      
      this.latestDate = moment(mainData.reopeningData.lastUpdated).format('MMM D, YYYY')
      // Pre-process test sites
      mainData.testSites2 = mainData.testSites2
        .map(d => {
          let kindOfTest = d["Kind of test"] || ""
          d.antibodyTest = kindOfTest.toLowerCase().indexOf("antibody") != -1 ? "Yes" : "No"
          d.coordinates = projection([+d.x, +d.y])
          d.stateName =
            stateCodes
              .filter(sc => sc.code == d["State or Territory"])
              .map(sc => sc.name)[0] || d["State or Territory"]
          return d
        })
        .filter(d => d.coordinates && d.coordinates[0] && d.coordinates[1])
        // .slice(0, 12000)
      console.log((Date.now() - dateTime)/1)
      dateTime = Date.now()

      mainData.clinicalTrialCoordinates = mainData.clinicalTrials
        .map(d => {
          if (!d.Coordinates) return d
          let lastComma = d.Coordinates.lastIndexOf(",")
          if (lastComma === -1) return d
          d.coordinates = d.Coordinates.substring(0, lastComma)
            .split(",")
            .map(
              c =>
                +c
                  .trim()
                  .replace("@", "")
                  .replace("]", "")
                  .replace("[", "")
            )
          return d
        })
        .filter(d => d.coordinates && d.coordinates.length === 2)
        .map(d => {
          d.coordinates = projection(d.coordinates)
          return d
        })
        .filter(d => d.coordinates && d.coordinates[0] && d.coordinates[1])
        // .slice(0, 12000)
      
      console.log((Date.now() - dateTime)/1)
      dateTime = Date.now()


      // Pre-process mainData.casesData
      let fromTo = [
        {
          from: { county: "New York City", state: "New York" },
          to: [
            "Queens County, New York",
            "Kings County, New York",
            "Richmond County, New York",
            "Bronx County, New York",
            "New York County, New York"
          ]
        }
      ]
      console.log((Date.now() - dateTime)/1)
      dateTime = Date.now()


      let namesArr = Array.from(mainData.names).map(([key, value]) => ({ key, value }))
      fromTo.forEach(ft => {
        ft.to.forEach(to => {
          let name = namesArr.find(n => n.value == to)
          if (name) {
            name.value = `${ft.from.county}, ${ft.from.state}`
          }
        })
      })
      mainData.names = new Map(Array.from(namesArr, ({ key, value }) => [key, value]))
      console.log((Date.now() - dateTime)/1)
      dateTime = Date.now()


      namesArr.forEach(d => {
        if (d.key == 102) {
          d.level = 0
          d.levelName = 'Country'
        } else if (d.value.indexOf(',') == -1) {
          d.level = 1
          d.levelName = 'State'
        } else {
          d.level = 2
          d.levelName = 'County'
        }
      })
      console.log((Date.now() - dateTime)/1)
      dateTime = Date.now()


      console.log((Date.now() - dateTime)/1)
      console.log("concat")
      dateTime = Date.now()
      let that = this
      await (async function () {
        setTimeout(() => {
          that.allLocations = namesArr.concat([])
        },1)
      })()


      console.log((Date.now() - dateTime)/1)
      console.log("county full name")
      dateTime = Date.now()


      // add county full name in each record
      mainData.casesData.forEach(d => {
        d.fullName = `${d.county}{areaName}, ${d.state}`
      })
      // mainData.nytcasesData.forEach(d => {
      //   d.fullName = `${d.county}{areaName}, ${d.state}`
      // })

      console.log((Date.now() - dateTime)/1)
      console.log("Calculate active cases")
      dateTime = Date.now()
      let dt
      let time11 = 0
      let time12 = 0
      let time13 = 0
      let time2 = 0
      let time3 = 0
      let time4 = 0
      let time5 = 0
      let time6 = 0
      
      // Calculate active cases
      // Calculate 7day active dif
      let getAvg = nums => {
        const sum = nums.reduce((a, b) => a + b, 0)
        const avg = sum / nums.length || 0
        return avg
      }
      let getSum = nums => {
        const sum = nums.reduce((a, b) => a + b, 0)
        return sum
      }
      let calc = (() => {
        let b
        let x = {
          sum: 0,
          doubleSum: 0,
          pastSum: 0,
          avg: 0,
          // pastAvg: 0,
          
          init(base) {
            b = base,
            values = []
            x.sum = 0
            x.doubleSum = 0
            x.pastSum = 0
            x.avg = 0
            // x.pastAvg = 0
          },
          add(v) {
            values.push(v)
            x.sum += v
            x.doubleSum += v
            if (values.length > b) {
              x.sum -= values[values.length - 1 - b]
              if (values.length > 2*b) {
                x.doubleSum -= values[values.length - 1 - 2*b]
              }
              // x.pastAvg = (x.doubleSum - x.sum)/Math.min(b, values.length - b)
            }
            x.avg = x.sum/Math.min(b, values.length)
            x.pastSum = x.doubleSum - x.sum
          },
        }
        let values = []

        return x
      })
      // calc.init(7)
      // calc.add(4)
      // calc.sum
      // calc.avg
      // calc.doubleSum
      let calcCases = calc()
      let calcDeaths = calc()
      _.each(this.groupBy(mainData.casesData, "fullName"), (arr, county) => {
        let casesByDate = _.orderBy(arr, ["date"], ["asc"])
        let pastCases = 0
        let pastDeaths = 0
        // let pastNCases = []
        // let pastNDeaths = []
        let dayAverage = 7
        calcCases.init(7)
        calcDeaths.init(7)
        casesByDate.forEach(d => {
          // dt = Date.now()
          d.newCases = d.cases - pastCases
          // time11 += Date.now() - dt
          // dt = Date.now()
          d.newDeaths = d.deaths - pastDeaths
          // time12 += Date.now() - dt
          // dt = Date.now()

          // d.activeCases = getSum(pastNCases.slice(-dayAverage * 2))
          // if (d.activeCases != calcCases.doubleSum()) debugg
          d.activeCases = calcCases.doubleSum

          // time13 += Date.now() - dt
          // dt = Date.now()

          // pastNCases.push(+d.newCases)
          // pastNDeaths.push(+d.newDeaths)

          // d.averageCases = getAvg(pastNCases.slice(-dayAverage))
          // if (d.averageCases != calcCases.avg) debugger
          d.averageCases = calcCases.avg
          // d.averageDeaths = getAvg(pastNDeaths.slice(-dayAverage))
          // if (d.averageDeaths != calcDeaths.avg) debugger
          d.averageDeaths = calcDeaths.avg

          calcCases.add(+d.newCases)
          calcDeaths.add(+d.newDeaths)

          // time2 += Date.now() - dt
          // dt = Date.now()
          
          // d.newCasesPeriod = getSum(pastNCases.slice(-dayAverage))
          // if (d.newCasesPeriod != calcCases.sum) debugger
          d.newCasesPeriod = calcCases.sum
          // let newCasesPastPeriod = getSum(
          //   pastNCases.slice(-dayAverage * 2, pastNCases.length - dayAverage)
          // )
          // if (newCasesPastPeriod != calcCases.pastSum) debugger
          let newCasesPastPeriod = calcCases.pastSum
          d.difCases = d.newCasesPeriod - newCasesPastPeriod
          d.difCasesPct = d.difCases / newCasesPastPeriod

          // time3 += Date.now() - dt
          // dt = Date.now()
          
          // d.newDeathsPeriod = getSum(pastNDeaths.slice(-dayAverage))
          // if (d.newDeathsPeriod != calcDeaths.sum) debugger
          d.newDeathsPeriod = calcDeaths.sum
          // let newDeathsPastPeriod = getSum(
          //   pastNDeaths.slice(-dayAverage * 2, pastNDeaths.length - dayAverage)
          // )
          // if (newDeathsPastPeriod != calcDeaths.pastSum) debugger
          let newDeathsPastPeriod = calcDeaths.pastSum
          d.difDeaths = d.newDeathsPeriod - newDeathsPastPeriod
          d.difDeathsPct = d.difDeaths / newDeathsPastPeriod



          // time4 += Date.now() - dt
          // dt = Date.now()
          
          // pastNCases = pastNCases.slice(-dayAverage * 2)
          // pastNDeaths = pastNDeaths.slice(-dayAverage * 2)

          pastCases = d.cases
          pastDeaths = d.deaths

          // time5 += Date.now() - dt
        })
      })
      _.each(this.groupBy(mainData.southAfricaCovidData, "county"), (arr, county) => {
        let casesByDate = _.orderBy(arr, ["date"], ["asc"])
        let pastCases = 0
        let pastDeaths = 0
        // let pastNCases = []
        // let pastNDeaths = []
        let dayAverage = 7
        calcCases.init(7)
        calcDeaths.init(7)
        casesByDate.forEach(d => {
          // dt = Date.now()
          d.newCases = d.cases - pastCases
          // time11 += Date.now() - dt
          // dt = Date.now()
          d.newDeaths = d.deaths - pastDeaths
          // time12 += Date.now() - dt
          // dt = Date.now()

          // d.activeCases = getSum(pastNCases.slice(-dayAverage * 2))
          // if (d.activeCases != calcCases.doubleSum()) debugg
          d.activeCases = calcCases.doubleSum

          // time13 += Date.now() - dt
          // dt = Date.now()

          // pastNCases.push(+d.newCases)
          // pastNDeaths.push(+d.newDeaths)

          // d.averageCases = getAvg(pastNCases.slice(-dayAverage))
          // if (d.averageCases != calcCases.avg) debugger
          d.averageCases = calcCases.avg
          // d.averageDeaths = getAvg(pastNDeaths.slice(-dayAverage))
          // if (d.averageDeaths != calcDeaths.avg) debugger
          d.averageDeaths = calcDeaths.avg

          calcCases.add(+d.newCases)
          calcDeaths.add(+d.newDeaths)

          // time2 += Date.now() - dt
          // dt = Date.now()
          
          // d.newCasesPeriod = getSum(pastNCases.slice(-dayAverage))
          // if (d.newCasesPeriod != calcCases.sum) debugger
          d.newCasesPeriod = calcCases.sum
          // let newCasesPastPeriod = getSum(
          //   pastNCases.slice(-dayAverage * 2, pastNCases.length - dayAverage)
          // )
          // if (newCasesPastPeriod != calcCases.pastSum) debugger
          let newCasesPastPeriod = calcCases.pastSum
          d.difCases = d.newCasesPeriod - newCasesPastPeriod
          d.difCasesPct = d.difCases / newCasesPastPeriod

          // time3 += Date.now() - dt
          // dt = Date.now()
          
          // d.newDeathsPeriod = getSum(pastNDeaths.slice(-dayAverage))
          // if (d.newDeathsPeriod != calcDeaths.sum) debugger
          d.newDeathsPeriod = calcDeaths.sum
          // let newDeathsPastPeriod = getSum(
          //   pastNDeaths.slice(-dayAverage * 2, pastNDeaths.length - dayAverage)
          // )
          // if (newDeathsPastPeriod != calcDeaths.pastSum) debugger
          let newDeathsPastPeriod = calcDeaths.pastSum
          d.difDeaths = d.newDeathsPeriod - newDeathsPastPeriod
          d.difDeathsPct = d.difDeaths / newDeathsPastPeriod



          // time4 += Date.now() - dt
          // dt = Date.now()
          
          // pastNCases = pastNCases.slice(-dayAverage * 2)
          // pastNDeaths = pastNDeaths.slice(-dayAverage * 2)

          pastCases = d.cases
          pastDeaths = d.deaths

          // time5 += Date.now() - dt
        })
      })
      // _.each(this.groupBy(mainData.nytcasesData, "fullName"), (arr, county) => {
      //   let casesByDate = _.orderBy(arr, ["date"], ["asc"])
      //   let pastCases = 0
      //   let pastDeaths = 0
      //   // let pastNCases = []
      //   // let pastNDeaths = []
      //   let dayAverage = 7
      //   calcCases.init(7)
      //   calcDeaths.init(7)
      //   casesByDate.forEach(d => {
      //     // dt = Date.now()
      //     d.newCases = d.cases - pastCases
      //     // time11 += Date.now() - dt
      //     // dt = Date.now()
      //     d.newDeaths = d.deaths - pastDeaths
      //     // time12 += Date.now() - dt
      //     // dt = Date.now()

      //     // d.activeCases = getSum(pastNCases.slice(-dayAverage * 2))
      //     // if (d.activeCases != calcCases.doubleSum()) debugg
      //     d.activeCases = calcCases.doubleSum

      //     // time13 += Date.now() - dt
      //     // dt = Date.now()

      //     // pastNCases.push(+d.newCases)
      //     // pastNDeaths.push(+d.newDeaths)

      //     // d.averageCases = getAvg(pastNCases.slice(-dayAverage))
      //     // if (d.averageCases != calcCases.avg) debugger
      //     d.averageCases = calcCases.avg
      //     // d.averageDeaths = getAvg(pastNDeaths.slice(-dayAverage))
      //     // if (d.averageDeaths != calcDeaths.avg) debugger
      //     d.averageDeaths = calcDeaths.avg

      //     calcCases.add(+d.newCases)
      //     calcDeaths.add(+d.newDeaths)

      //     // time2 += Date.now() - dt
      //     // dt = Date.now()
          
      //     // d.newCasesPeriod = getSum(pastNCases.slice(-dayAverage))
      //     // if (d.newCasesPeriod != calcCases.sum) debugger
      //     d.newCasesPeriod = calcCases.sum
      //     // let newCasesPastPeriod = getSum(
      //     //   pastNCases.slice(-dayAverage * 2, pastNCases.length - dayAverage)
      //     // )
      //     // if (newCasesPastPeriod != calcCases.pastSum) debugger
      //     let newCasesPastPeriod = calcCases.pastSum
      //     d.difCases = d.newCasesPeriod - newCasesPastPeriod
      //     d.difCasesPct = d.difCases / newCasesPastPeriod

      //     // time3 += Date.now() - dt
      //     // dt = Date.now()
          
      //     // d.newDeathsPeriod = getSum(pastNDeaths.slice(-dayAverage))
      //     // if (d.newDeathsPeriod != calcDeaths.sum) debugger
      //     d.newDeathsPeriod = calcDeaths.sum
      //     // let newDeathsPastPeriod = getSum(
      //     //   pastNDeaths.slice(-dayAverage * 2, pastNDeaths.length - dayAverage)
      //     // )
      //     // if (newDeathsPastPeriod != calcDeaths.pastSum) debugger
      //     let newDeathsPastPeriod = calcDeaths.pastSum
      //     d.difDeaths = d.newDeathsPeriod - newDeathsPastPeriod
      //     d.difDeathsPct = d.difDeaths / newDeathsPastPeriod



      //     // time4 += Date.now() - dt
      //     // dt = Date.now()
          
      //     // pastNCases = pastNCases.slice(-dayAverage * 2)
      //     // pastNDeaths = pastNDeaths.slice(-dayAverage * 2)

      //     pastCases = d.cases
      //     pastDeaths = d.deaths

      //     // time5 += Date.now() - dt
      //   })
      // })
      console.log({time11, time12, time13, time2, time3, time4, time5})
      console.log((Date.now() - dateTime)/1)
      console.log("getStateMinMax()")
      dateTime = Date.now()


      mainData.stateMinMaxFn = () =>
        _.map(
          this.groupBy(mainData.casesData, "state"),
          (arr, state) =>
            _.map(this.groupBy(arr, "date"), (cases, date) => {
              let info = {
                state: state,
                date: date,
                activeCases: cases.map(d => +d.activeCases).reduce(sum, 0),
                cases: cases.map(d => +d.cases).reduce(sum, 0),
                deaths: cases.map(d => +d.deaths).reduce(sum, 0),
                newCases: cases.map(d => +d.newCases).reduce(sum, 0),
                newDeaths: cases.map(d => +d.newDeaths).reduce(sum, 0),
                averageCases: cases.map(d => +d.averageCases).reduce(sum, 0),
                averageDeaths: cases.map(d => +d.averageDeaths).reduce(sum, 0),
                newCasesPeriod: cases.map(d => +d.newCasesPeriod).reduce(sum, 0),
                newDeathsPeriod: cases.map(d => +d.newDeathsPeriod).reduce(sum, 0),
                difCases: cases.map(d => +d.difCases).reduce(sum, 0),
                difDeaths: cases.map(d => +d.difDeaths).reduce(sum, 0),
                minCases: Math.min(0, ...cases.map(d => +d.cases)),
                maxCases: Math.max(0, ...cases.map(d => +d.cases)),
                minDeaths: Math.min(0, ...cases.map(d => +d.deaths)),
                maxDeaths: Math.max(0, ...cases.map(d => +d.deaths)),
                minActiveCases: Math.min(0, ...cases.map(d => +d.activeCases)),
                maxActiveCases: Math.max(0, ...cases.map(d => +d.activeCases)),
                total: cases.map(d => +d.cases).reduce(sum, 0)
              }
              info.difCasesPct = info.difCases / (info.newCasesPeriod - info.difCases)
              info.difDeathsPct = info.difDeaths / (info.newDeathsPeriod - info.difDeaths)
              return info
            })
        ).flat()

      console.log((Date.now() - dateTime)/1)
      console.log("groupedByCounty")
      dateTime = Date.now()

      // let dt
      // let time1 = 0
      // let time2 = 0
      // let time3 = 0

      let groupedByCounty = this.groupBy(mainData.casesData, "fullName")
      let allNames = [...mainData.names.entries()]
      for (let ix in groupedByCounty) {
        // dt = Date.now()
        var areaNames = [
          ix.replace("{areaName}", " County"),
          ix.replace("{areaName}", " Parish"),
          ix.replace("{areaName}", " Municipality"),
          ix.replace("{areaName}", " Census Area"),
          ix.replace("{areaName}", "")
        ]
        // time1 += Date.now() - dt
        // dt = Date.now()
        let arr = groupedByCounty[ix]
        
        let locations
        if (ix == "New York City{areaName}, New York") {

          locations = allNames
            .filter(d => areaNames.includes(d[1]))
            // .filter(({ 1: v }) => areaNames.includes(v))
            .map(d => d[0])
        } else {
          locations = allNames
            // .find(({ 1: v }) => areaNames.indexOf(v) != -1)
            .find(d => areaNames.includes(d[1]))
          locations = [locations ? locations[0] : null]
        }
        
//         let locations = allNames
//           // .filter(({ 1: v }) => areaNames.indexOf(v) != -1)
//           // // .filter(({ 1: v }) => areaNames.includes(v))
//           // .map(([k]) => k)
//           .find(({ 1: v }) => areaNames.indexOf(v) != -1)
//           locations = [locations ? locations[0] : null]
// // debugger
//         if (locations.length == 0) {
//           // console.log("name/location match error")
//           // console.log(ix)
//           // window.nlErrors = window.nlErrors || []
//           // window.nlErrors.push(ix)
//         }
        // time2 += Date.now() - dt
        // dt = Date.now()

        if (locations.length) {
          arr.forEach(d => {
            d.location = locations[0]
          })
          locations.forEach((loc, ix) => {
            if (ix == 0) return

            let cloneArr = JSON.parse(JSON.stringify(arr))
            cloneArr.forEach(d => {
              d.location = loc
            })
            mainData.casesData.push(...cloneArr)
          })
        }
        // time3 += Date.now() - dt
      }
      console.log((Date.now() - dateTime)/1)
      // console.log({time1, time2, time3})
      dateTime = Date.now()

      // this.loading = false

    },

    updateCountyCasesChart: function(countyFullName, locationId) {
      // Filter and transform data
      
      let casesByDate = _.map(
        _.groupBy(
          mainData.southAfricaCovidData.filter(d => d.county.toLowerCase() === locationId.toLowerCase()),
          // mainData.casesData.filter(d => d.location === locationId),
          "date"
        ),
        (arr, date) => ({
          date: date,
          cases: arr.map(d => +d.cases).reduce(sum, 0),
          deaths: arr.map(d => +d.cases).reduce(sum, 0)
        })
      )
      casesByDate = _.orderBy(casesByDate, ["date"], ["asc"])
      let pastCases = 0
      let pastDeaths = 0
      let pastNCases = []
      let dayAverage = 7
      let minCases = 20
      let firstIxOverMin = 0
      casesByDate.forEach((d, ix) => {
        if (firstIxOverMin === 0 && +d.cases >= minCases) {
          firstIxOverMin = ix
        }
        d.newCases = d.cases - pastCases
        d.newDeaths = d.deaths - pastDeaths

        pastNCases.push(d.newCases)
        pastNCases = pastNCases.splice(
          Math.max(0, pastNCases.length - dayAverage),
          dayAverage
        )
        d.average = pastNCases.reduce(sum, 0) / pastNCases.length

        pastCases = d.cases
        pastDeaths = d.deaths
      })
      casesByDate.splice(0, firstIxOverMin)

      let data = casesByDate.map(d => ({
        date: this.timeParse(d.date),
        newCases: d.newCases,
        average: d.average
      }))

      var margin = { top: 20, right: 20, bottom: 30, left: 40 },
        width = 850 - margin.left - margin.right,
        height = 200 - margin.top - margin.bottom

      // Set the ranges
      var x = d3
        .scaleBand()
        .rangeRound([0, width], 0.05)
        .padding(0.1)
      var y = d3.scaleLinear().range([height, 0])

      // Scale the range of the data in the domains
      x.domain(
        data.map(function(d) {
          return d.date
        })
      )
      y.domain([
        0,
        d3.max(data, function(d) {
          return d.newCases
        })
      ])

      // Create svg
      d3.select("#countyCasesChart svg").remove()
      var svg = d3
        .select("#countyCasesChart")
        .append("svg")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .style("width", "100%")
        .attr(
          "viewBox",
          `0 0 ${width + margin.left + margin.right} ${height +
            margin.top +
            margin.bottom}`
        )
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")")

      // Define tooltip
      d3.select("#countyCasesChart .tooltip-label")
      var tooltip = d3
        .select("#countyCasesChart")
        .append("div")
        .attr("class", "tooltip-label")
        .style("opacity", 0)

      let showTooltip = function(html) {
        let chartRect = d3
          .select("#countyCasesChart")
          .node()
          .getBoundingClientRect()
        tooltip
          .transition()
          .duration(200)
          .style("opacity", 0.93)
        tooltip
          .html(html)
          .style("left", d3.event.clientX - chartRect.x + "px")
          .style("top", d3.event.clientY - chartRect.y - 28 + "px")
      }

      let hideTooltip = function() {
        tooltip
          .transition()
          .duration(500)
          .style("opacity", 0)
      }

      // Add the x Axis
      let xAxis = d3
        .axisBottom()
        .scale(x)
        .tickFormat(d3.timeFormat("%b %d"))
      svg
        .append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + height + ")")
        .call(xAxis)
        .selectAll("text")
        .attr("transform", "translate(0,-3)rotate(315)")
        // .attr("transform", "translate(0,-3px)rotate(315)")
        .style("text-anchor", "end")

      // Add the y Axis
      svg.append("g").call(d3.axisLeft(y))

      // Add bar cases
      svg
        .selectAll(".bar")
        .data(data)
        .enter()
        .append("rect")
        .attr("fill", casesColor)
        .attr("class", "bar")
        .attr("x", function(d) {
          return x(d.date)
        })
        .attr("width", x.bandwidth())
        .attr("y", function(d) {
          return y(d.newCases)
        })
        .attr("height", function(d) {
          return height - y(d.newCases)
        })
        .on("mouseover", function(d) {
          d3.select(this).attr("fill", casesColorHover)
          showTooltip(
            `<b>${d3.timeFormat("%b %d")(d.date)}</b><br>${format(
              d.newCases
            )} cases`
          )
        })
        .on("mouseout", function(d) {
          d3.select(this).attr("fill", casesColor)
          hideTooltip()
        })

      // Add line average
      var line = d3
        .line()
        .x(function(d, i) {
          return x(d.date)
        })
        .y(function(d) {
          return y(d.average)
        })
        .curve(d3.curveMonotoneX) // apply smoothing to the line
      let lineG = svg.append("g")
      lineG
        .append("path")
        .datum(data)
        .attr("class", "line")
        .attr("fill", "none")
        .attr("stroke", lineColor)
        .attr("stroke-width", "3")
        .attr("d", line)

      // Add dots on average
      lineG
        .selectAll(".dot")
        .data(data)
        .enter()
        .append("circle")
        .attr("class", "dot")
        .attr("fill", lineColor)
        .attr("cx", function(d, i) {
          return x(d.date)
        })
        .attr("cy", function(d) {
          return y(d.average)
        })
        .attr("r", 3)
        .on("mouseover", function(d) {
          d3.select(this)
            .attr("fill", dotColorHover)
            .raise()
          showTooltip(
            `<b>${d3.timeFormat("%b %d")(d.date)}</b><br>${formatNoDecimal(
              d.average
            )} cases (7-day average)`
          )
        })
        .on("mouseout", function() {
          d3.select(this)
            .attr("fill", lineColor)
            .raise()
          hideTooltip()
        })
    },

    getStateReopeningData: function(stateName) {
      // Filter and transform data
      let stateReopeningRecords = mainData.reopeningData.openings.filter(
        d => d.state.trim() === stateName
      )

      let stateReopeningData = stateReopeningRecords.reduce((a, b) => {
        let c = _.clone(a)
        _.each(
          b,
          (val, field) => (c[field] = val === 0 || !!val ? val : c[field])
        )
        return c
      }, {})

      return stateReopeningData
    },

    updateReopeningStatusChart: function(stateName) {
      // let stateReopeningData = this.getStateReopeningData(stateName)

      // let data = [
      //   {
      //     category: "Travel",
      //     status: "closed",
      //     dateStart: stateReopeningData.travelShutdown,
      //     dateEnd: stateReopeningData.travelOpen
      //   },
      //   {
      //     category: "Travel",
      //     status: "open",
      //     dateStart: stateReopeningData.travelOpen,
      //     statusColor: stateReopeningData.travelButtonColor
      //   },
      //   {
      //     category: "People",
      //     status: "closed",
      //     dateStart: stateReopeningData.peopleShutdown,
      //     dateEnd: stateReopeningData.peopleOpen
      //   },
      //   {
      //     category: "People",
      //     status: "open",
      //     dateStart: stateReopeningData.peopleOpen,
      //     statusColor: stateReopeningData.peopleButtonColor
      //   },
      //   {
      //     category: "Gathering",
      //     status: "closed",
      //     dateStart: stateReopeningData.gatheringShutdown,
      //     dateEnd: stateReopeningData.gatheringOpen
      //   },
      //   {
      //     category: "Gathering",
      //     status: "open",
      //     dateStart: stateReopeningData.gatheringOpen,
      //     statusColor: stateReopeningData.gatheringButtonColor
      //   },
      //   {
      //     category: "Medical",
      //     status: "closed",
      //     dateStart: stateReopeningData.medicalShutdown,
      //     dateEnd: stateReopeningData.medicalOpen
      //   },
      //   {
      //     category: "Medical",
      //     status: "open",
      //     dateStart: stateReopeningData.medicalOpen,
      //     statusColor: stateReopeningData.medicalButtonColor
      //   },
      //   {
      //     category: "Schools",
      //     status: "closed",
      //     dateStart: stateReopeningData.schoolsShutdown,
      //     dateEnd: stateReopeningData.schoolsOpen
      //   },
      //   {
      //     category: "Schools",
      //     status: "open",
      //     dateStart: stateReopeningData.schoolsOpen,
      //     statusColor: stateReopeningData.schoolsButtonColor
      //   },
      //   {
      //     category: "Childcare",
      //     status: "closed",
      //     dateStart: stateReopeningData.childcareShutdown,
      //     dateEnd: stateReopeningData.childcareOpen
      //   },
      //   {
      //     category: "Childcare",
      //     status: "open",
      //     dateStart: stateReopeningData.childcareOpen,
      //     statusColor: stateReopeningData.childcareButtonColor
      //   },
      //   {
      //     category: "Public",
      //     status: "closed",
      //     dateStart: stateReopeningData.publicShutdown,
      //     dateEnd: stateReopeningData.publicOpen
      //   },
      //   {
      //     category: "Public",
      //     status: "open",
      //     dateStart: stateReopeningData.publicOpen,
      //     statusColor: stateReopeningData.publicButtonColor
      //   },
      //   {
      //     category: "Retail",
      //     status: "closed",
      //     dateStart: stateReopeningData.retailShutdown,
      //     dateEnd: stateReopeningData.retailOpen
      //   },
      //   {
      //     category: "Retail",
      //     status: "open",
      //     dateStart: stateReopeningData.retailOpen,
      //     statusColor: stateReopeningData.retailButtonColor
      //   },
      //   {
      //     category: "Restaurants",
      //     status: "closed",
      //     dateStart: stateReopeningData.restaurantsShutdown,
      //     dateEnd: stateReopeningData.restaurantsOpen
      //   },
      //   {
      //     category: "Restaurants",
      //     status: "open",
      //     dateStart: stateReopeningData.restaurantsOpen,
      //     statusColor: stateReopeningData.restaurantsButtonColor
      //   },
      //   {
      //     category: "Entertainment",
      //     status: "closed",
      //     dateStart: stateReopeningData.entretainmentShutdown,
      //     dateEnd: stateReopeningData.entretainmentOpen
      //   },
      //   {
      //     category: "Entertainment",
      //     status: "open",
      //     dateStart: stateReopeningData.entretainmentOpen,
      //     statusColor: stateReopeningData.entretainmentButtonColor
      //   },
      //   {
      //     category: "Bars",
      //     status: "closed",
      //     dateStart: stateReopeningData.barsShutdown,
      //     dateEnd: stateReopeningData.barsOpen
      //   },
      //   {
      //     category: "Bars",
      //     status: "open",
      //     dateStart: stateReopeningData.barsOpen,
      //     statusColor: stateReopeningData.barsButtonColor
      //   },
      //   {
      //     category: "Gyms",
      //     status: "closed",
      //     dateStart: stateReopeningData.gymsShutdown,
      //     dateEnd: stateReopeningData.gymsOpen
      //   },
      //   {
      //     category: "Gyms",
      //     status: "open",
      //     dateStart: stateReopeningData.gymsOpen,
      //     statusColor: stateReopeningData.gymsButtonColor
      //   },
      //   {
      //     category: "Close-Contact Biz",
      //     status: "closed",
      //     dateStart: stateReopeningData.closeContactBizShutdown,
      //     dateEnd: stateReopeningData.closeContactBizOpen
      //   },
      //   {
      //     category: "Close-Contact Biz",
      //     status: "open",
      //     dateStart: stateReopeningData.closeContactBizOpen,
      //     statusColor: stateReopeningData.closeContactBizButtonColor
      //   },
      //   {
      //     category: "Worship",
      //     status: "closed",
      //     dateStart: stateReopeningData.worshipShutdown,
      //     dateEnd: stateReopeningData.worshipOpen
      //   },
      //   {
      //     category: "Worship",
      //     status: "open",
      //     dateStart: stateReopeningData.worshipOpen,
      //     statusColor: stateReopeningData.worshipButtonColor
      //   }
      // ]


      let dataFields = [
        {
          category: "Travel",
          status: "closed",
          dateStart: "travelShutdown",
          dateEnd: "travelOpen",
          statusColor: "travelButtonColor",
        },
        {
          category: "People",
          status: "closed",
          dateStart: "peopleShutdown",
          dateEnd: "peopleOpen",
          statusColor: "peopleButtonColor",
        },
        {
          category: "Gathering",
          status: "closed",
          dateStart: "gatheringShutdown",
          dateEnd: "gatheringOpen",
          statusColor: "gatheringButtonColor",
        },
        {
          category: "Medical",
          status: "closed",
          dateStart: "medicalShutdown",
          dateEnd: "medicalOpen",
          statusColor: "medicalButtonColor",
        },
        {
          category: "Schools",
          status: "closed",
          dateStart: "schoolsShutdown",
          dateEnd: "schoolsOpen",
          statusColor: "schoolsButtonColor",
        },
        {
          category: "Childcare",
          status: "closed",
          dateStart: "childcareShutdown",
          dateEnd: "childcareOpen",
          statusColor: "childcareButtonColor",
        },
        {
          category: "Public",
          status: "closed",
          dateStart: "publicShutdown",
          dateEnd: "publicOpen",
          statusColor: "publicButtonColor",
        },
        {
          category: "Retail",
          status: "closed",
          dateStart: "retailShutdown",
          dateEnd: "retailOpen",
          statusColor: "retailButtonColor",
        },
        {
          category: "Restaurants",
          status: "closed",
          dateStart: "restaurantsShutdown",
          dateEnd: "restaurantsOpen",
          statusColor: "restaurantsButtonColor",
        },
        {
          category: "Entertainment",
          status: "closed",
          dateStart: "entretainmentShutdown",
          dateEnd: "entretainmentOpen",
          statusColor: "entretainmentButtonColor",
        },
        {
          category: "Bars",
          status: "closed",
          dateStart: "barsShutdown",
          dateEnd: "barsOpen",
          statusColor: "barsButtonColor",
        },
        {
          category: "Gyms",
          status: "closed",
          dateStart: "gymsShutdown",
          dateEnd: "gymsOpen",
          statusColor: "gymsButtonColor",
        },
        {
          category: "Close-Contact Biz",
          status: "closed",
          dateStart: "closeContactBizShutdown",
          dateEnd: "closeContactBizOpen",
          statusColor: "closeContactBizButtonColor",
        },
        {
          category: "Worship",
          status: "closed",
          dateStart: "worshipShutdown",
          dateEnd: "worshipOpen",
          statusColor: "worshipButtonColor",
        },
      ]

      let stateReopeningRecords = mainData.reopeningData.openings.filter(
        d => d.state.trim() === stateName
      )
      stateReopeningRecords = _.orderBy(stateReopeningRecords, ['effectiveDate'])
      
      let bars = []
      let newBar = {}
      dataFields.forEach(fields => {
        newBar = {}

        stateReopeningRecords.forEach(record => {
          let vaildDateStart = this.timeParse(record[fields.dateStart]) || null
          let validDateEnd = this.timeParse(record[fields.dateEnd]) || null

          if (!newBar.dateStart && vaildDateStart) {
            newBar.status = "closed"
            newBar.category = fields.category
            newBar.dateStart = record[fields.dateStart] || null
            newBar.statusColor = record[fields.statusColor] || null
            bars.push(newBar)
          } else if (vaildDateStart) {
            newBar.dateEnd = record[fields.dateStart] || null

            newBar = {}
            newBar.status = "closed"
            newBar.category = fields.category
            newBar.dateStart = record[fields.dateStart] || null
            newBar.statusColor = record[fields.statusColor] || null
            bars.push(newBar)
          }

          if (validDateEnd) {
            newBar.dateEnd = record[fields.dateEnd] || null

            
            newBar = {}
            newBar.status = "open"
            newBar.category = fields.category
            newBar.dateStart = record[fields.dateEnd] || null
            newBar.statusColor = record[fields.statusColor] || null
            bars.push(newBar)
          }

        })
      })
      
      let pastBar = null
      _.orderBy(bars, ['category', 'dateStart'], ['desc', 'desc']).forEach(bar => {
        if (!bar.dateEnd && !moment(bar.dateStart).isAfter(moment())) {
            bar.dateEnd = new Date()
        } else if (pastBar && bar.category == pastBar.category) {
          bar.dateEnd = pastBar.dateStart
        }
        pastBar = bar
      })


      let data = bars



      data = data.filter(
        d => d.dateStart && moment(d.dateStart).isSameOrAfter("2020-01-01")
      )
      data.forEach(d => {
        d.dateStart = this.timeParse(d.dateStart)
        d.dateEnd = this.timeParse(d.dateEnd)
        if (d.dateStart && !d.dateEnd) {
          if (moment(d.dateStart).isAfter(moment())) {
            d.dateEnd = d.dateStart
          } else {
            d.dateEnd = new Date()
          }
        }
        d.color =
          d.status == "open"
            ? d.statusColor.toLowerCase() == "green"
              ? green
              : yellow
            : d.status == "closed"
            ? red
            : yellow
      })
      console.log("bars")
      console.log(data)
      let categories = _.uniq(data.map(d => d.category)).reverse()

      var margin = { top: 20, right: 20, bottom: 30, left: 90 },
        width = 850 - margin.left - margin.right,
        height = 300 - margin.top - margin.bottom

      // Create svg
      d3.select("#reopeningStatusChart svg").remove()
      var svg = d3
        .select("#reopeningStatusChart")
        .append("svg")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .style("width", "100%")
        .attr(
          "viewBox",
          `0 0 ${width + margin.left + margin.right} ${height +
            margin.top +
            margin.bottom}`
        )
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")")

      // Set the ranges
      // var x = d3.scaleBand()
      //   .rangeRound([0, width], .05)
      //   .padding(0.1)
      // var y = d3.scaleLinear()
      //         .range([height, 0])

      var x = d3.scaleTime().range([0, width])
      // .padding(0.1)
      var y = d3.scaleBand().rangeRound([height, 0], 0.05)

      // Scale the range of the data in the domains
      let minDate = this.timeParse("2020-02-25")
      let maxDate = this.timeParse(
        moment()
          .add(2, "days")
          .format("YYYY-MM-DD")
      )
      x.domain([minDate, maxDate])
      y.domain(categories)

      // Add the x Axis
      let xAxis = d3
        .axisBottom()
        .scale(x)
        // .tickFormat(d3.timeFormat("%b"))
        .tickFormat(d3.timeFormat("%b %d"))
        .ticks(d3.timeMonth.every(1))
      svg
        .append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + height + ")")
        .call(xAxis)
        .selectAll("text")
        .style("text-anchor", "start")

      // Add the y Axis
      let yAxis = d3.axisLeft(y)
      svg
        .append("g")
        .attr("class", "y axis")
        .call(yAxis)
        .selectAll("text")
        .style("text-anchor", "end")
      // .attr("transform", "translate(20,0)")

      // Add bar cases
      let barWidth = 5
      svg
        .selectAll(".bar")
        .data(data)
        .enter()
        .append("rect")
        .attr("fill", d => d.color)
        .attr("class", "bar")
        .attr("x", function(d) {
          return x(d.dateStart)
        })
        .attr("width", function(d) {
          return x(d.dateEnd) - x(d.dateStart)
        })
        .attr("y", function(d) {
          return y(d.category) + (y.bandwidth() - barWidth) / 2
        })
        .attr("height", `${barWidth}px`)

      // Add todays line
      svg
        .append("svg:line")
        .attr("class", "line")
        .attr("x1", x(new Date()))
        .attr("y1", y(0))
        .attr("x2", x(new Date()))
        .attr("y2", height)
        .style("stroke", "blue")
        .style("stroke-width", 2)
        .style("stroke-dasharray", "3, 3")

      // Define tooltip
      d3.select("#reopeningStatusChart .tooltip-label")
      var tooltip = d3
        .select("#reopeningStatusChart")
        .append("div")
        .attr("class", "tooltip-label")
        .style("opacity", 0)

      let showTooltip = function(html) {
        let chartRect = d3
          .select("#reopeningStatusChart")
          .node()
          .getBoundingClientRect()
        tooltip
          .transition()
          .duration(200)
          .style("opacity", 0.93)
        tooltip
          .html(html)
          .style("left", d3.event.clientX - chartRect.x + "px")
          .style("top", d3.event.clientY - chartRect.y - 28 + "px")
      }

      let hideTooltip = function() {
        tooltip
          .transition()
          .duration(500)
          .style("opacity", 0)
      }

      let stopSymbol = {
        filter: d => d.status.toLowerCase() == "closed",
        statusDisplay: "Closed",
        data: [
          { x: 8.878, y: 0 },
          { x: 21.213, y: 0 },
          { x: 30.0, y: 8.878 },
          { x: 30.0, y: 21.213 },
          { x: 21.213, y: 30.0 },
          { x: 8.878, y: 30.0 },
          { x: 0, y: 21.213 },
          { x: 0, y: 8.878 }
        ],
        color: red,
        hoverColor: red,
        curveFn: d3.curveLinear
      }

      let warningSymbol = {
        filter: d =>
          d.status.toLowerCase() == "open" &&
          d.statusColor.toLowerCase() != "green",
        statusDisplay: "Open with restrictions",
        data: [
          { x: 15, y: 3 },
          { x: 30, y: 28.98 },
          { x: 0, y: 28.98 }
        ],
        color: yellow,
        hoverColor: yellow,
        curveFn: d3.curveLinear
      }

      let okSymbol = {
        filter: d =>
          d.status.toLowerCase() == "open" &&
          d.statusColor.toLowerCase() == "green",
        statusDisplay: "Open",
        data: [
          { x: 10, y: 0 },
          { x: 20, y: 0 },
          { x: 30, y: 10 },
          { x: 30, y: 20 },
          { x: 20, y: 30 },
          { x: 10, y: 30 },
          { x: 0, y: 20 },
          { x: 0, y: 10 },
          { x: 10, y: 0 }
        ],
        color: green,
        hoverColor: green,
        curveFn: d3.curveMonotoneX
      }

      let drawSymbols = function(instructions) {
        var lineFn = d3
          .line()
          .x(function(d, i) {
            return d.x
          })
          .y(function(d) {
            return d.y
          })
          .curve(instructions.curveFn)

        // Add dots on average
        let scale = 0.5
        svg
          .selectAll(".dot")
          .data(data.filter(instructions.filter))

          .enter()
          .append("path")
          .attr("transform", d => {
            return (
              "translate(" +
              (x(d.dateStart) - (30 * scale) / 2) +
              "," +
              (y(d.category) +
                (y.bandwidth() - barWidth) / 2 -
                (30 * scale) / 2 +
                barWidth / 2) +
              ")scale(0.5)"
            )
          })
          .on("mouseover", function(d) {
            d3.select(this).attr("fill", instructions.hoverColor)
            showTooltip(
              `<b>${d3.timeFormat("%b %d")(d.dateStart)}</b><br>${
                instructions.statusDisplay
              }`
            )
          })
          .on("mouseout", function(d) {
            d3.select(this).attr("fill", instructions.color)
            hideTooltip()
          })
          // .datum(instructions.data)
          .attr("fill", instructions.color)
          .attr("stroke", "none")
          .attr("d", lineFn(instructions.data))
        //   .append("circle")
        // .attr("class", "dot")
        // .attr("fill", lineColor)
        // .attr("cx", function(d, i) { return x(d.dateStart) })
        // .attr("cy", function(d) { return y(d.category) + ((y.bandwidth() - barWidth) / 2) })
        // .attr("r", 3)
      }

      drawSymbols(stopSymbol)
      drawSymbols(warningSymbol)
      drawSymbols(okSymbol)
    },

    displayCountyProfile: function(countyFullName, locationId, countryName) {
      let profile = d3.select(".county-profile")
      profile.style("display", "block")

      // Split county and state
      let countyName
      let stateName
      if (countryName) {
        countyName = countyFullName
        stateName = countryName
      } else {
        countyName = countyFullName.split(",")[0]
        stateName = countyFullName.split(",")[1].trim()
      }
      if (countyName) {
        countyName = countyName
          .replace("{areaName}", "")
          .replace(" County", "")
          .replace(" Parish", "")
          .replace(" Municipality", "")
          .replace(" Census Area", "")
          .trim()
      }

      profile.select(".name").text(countyName)

      let days = document.querySelector("#myRange").value
      let date = moment("2020-01-01")
        .add(days - 1, "days")
        .format("YYYY-MM-DD")
      // let cases = mainData.casesData.filter(
      //   d => d.location === locationId && d.date <= date
      // )
      let cases = mainData.southAfricaCovidData.filter(
        d => d.county.toLowerCase() === locationId.toLowerCase() && d.date <= date
      )
      cases = _.orderBy(cases, ["date"], ["desc"])[0]
      let maxCases = _.orderBy(
        mainData.casesData.filter(d => d.state === stateName && d.date <= date),
        ["date", d => +d.cases],
        ["desc", "desc"]
      )[0]
      if (cases) {
        profile
          .select(".cases-icon")
          .style("background", this.color2(+cases.cases / maxCases.cases))
        profile.select(".cases").text(`${format(+cases.cases)} cases`)
      } else {
        profile.select(".cases").text(`NA cases`)
      }

      // TODO: check this
      // Create Test Site Table
      mainData.countyTestSites = mainData.testSites2.filter(
        s =>
          this.toLowerTrimmed(s.stateName) == this.toLowerTrimmed(stateName) &&
          this.toLowerTrimmed(s.County) == this.toLowerTrimmed(countyName)
      )

      profile
        .select(".numTestSites")
        .text(`${mainData.countyTestSites.length} Test Sites`)
      if (mainData.countyTestSites.length === 0) {
        profile
          .select("#testSitesTable")
          .selectAll("tr")
          .remove()
        profile
          .select("#testSitesTable")
          .append("tr")
          .append("td")
          .append("i")
          .text("No test sites found.")
      } else {
        this.updateTestSitesTable()
      }

      // TODO: check this
      // Create Clinical Trial Site Table
      mainData.countyTrialSites = mainData.clinicalTrials.filter(
        s => s.State == stateName && s.County == countyName
      )
      // countyTrialSites = countyTrialSites.map()
      profile
        .select(".numTrialSites")
        .text(`${mainData.countyTrialSites.length} Clinical Trial Sites`)
      if (mainData.countyTrialSites.length === 0) {
        profile
          .select("#trialSitesTable")
          .selectAll("tr")
          .remove()
        profile
          .select("#trialSitesTable")
          .append("tr")
          .append("td")
          .append("i")
          .text("No clinical trials found.")
      } else {
        this.updateClinicalTrialsTable()
        // profile
        //   .select("#trialSitesTable")
        //   .append("tr")
        //   .attr("class", "header")
        //   .selectAll("th")
        //   .data(shownTrialSiteColumns)
        //   .enter()
        //   .append("th")
        //   .text(d => d.label)
        // let trTrialSite = profile
        //   .select("#trialSitesTable")
        //   .selectAll("tr.site")
        //   .data(countyTrialSites)
        //   .enter()
        //   .append("tr")
        // .on("click", d => {
        //   this.profilePanel = 3
        //   setTimeout(() => this.displayTrialSiteProfile(d))
        // })

        // trTrialSite.attr("class", "site")
        // trTrialSite
        //   .selectAll("td")
        //   .data((d, i) => Object.values(onlyShownForTrialSite(d)))
        //   .enter()
        //   .append("td")
        //   .html(d => d)
      }

      this.updateCountyCasesChart(countyFullName, locationId)

      // Display
      this.profile.showState = true
      this.profile.showCounty = true
      this.profile.showTestSites = false
      this.profile.showClinicalTrials = false
      // d3.select(".test-site-profile").style("display", "none")
      // d3.select(".trial-site-profile").style("display", "none")

      // Collapse
      // $(".accordion #collapseCounty").collapse("show")
    },

    updateTestSitesTable: function() {
      let profile = d3.select(".county-profile")

      let criteriaInfo = [
        // { toggleSelector: '.mustFallUnderGuidelines', filter: site => site.MustFallUnderGuidelines === false },
        // { toggleSelector: '.mustBeRiskPatient', filter: site => site.MustBeRiskPatient === false },
        {
          toggleSelector: ".prescriptionRequired",
          filter: site => site["Referral Required"] === "No",
        },
        {
          toggleSelector: ".needAppointment",
          filter: site => site["Appointment Only"] === "No",
        },
        {
          toggleSelector: ".antibodyTest",
          filter: site => site["antibodyTest"] === "Yes",
        }
        // { toggleSelector: '.mustBePatient', filter: site => site.MustBePatient === false },
      ]

      // Filter by criteria
      let criteriaFilters = criteriaInfo.filter(info =>
        $(info.toggleSelector).hasClass("selected")
      )
      let sites = mainData.countyTestSites
      criteriaFilters.forEach(info => {
        sites = sites.filter(s => info.filter(s))
      })

      let shownTestSiteColumns = [
        {
          label: "Name",
          name: "Name",
          html: d =>
            `<i class="test-site-icon material-icons">lens</i>&nbsp;&nbsp;<span class='site-name'>${d["Name of Facility"]}</span>`
        },
        {
          class: "toggle-header",
          label:
            "<i class='material-icons criteria-toggle-header' data-criteria-toggle='prescriptionRequired'>list_alt</i>",
          name: "Referral Required"
        },
        {
          class: "toggle-header",
          label:
            "<i class='material-icons criteria-toggle-header' data-criteria-toggle='needAppointment'>event_available</i>",
          name: "Appointment Only"
        },
        {
          class: "toggle-header",
          label:
            "<i class='material-icons criteria-toggle-header' data-criteria-toggle='antibodyTest'>science</i>",
          name: "antibodyTest"
        },
        { label: "Contact", name: "Phone" }
      ]
      let onlyShownForTestSite = d => {
        let values = _.map(shownTestSiteColumns, col => ({
          html: col.html ? col.html(d) : d[col.name],
          class: col.class
        }))
        return values
      }

      profile
        .select("#testSitesTable")
        .selectAll("tr")
        .remove()
      profile
        .select("#testSitesTable")
        .append("tr")
        .attr("class", "header")
        .selectAll("th")
        .data(shownTestSiteColumns)
        .enter()
        .append("th")
        .attr("class", d => d.class)
        .html(d => d.label)
      let trTestSite = profile
        .select("#testSitesTable")
        .selectAll("tr.site")
        .data(sites)
        .enter()
        .append("tr")
        .on("click", d => {
          this.profilePanel = 2
          setTimeout(() => this.displayTestSiteProfile(d))
        })
      trTestSite.attr("class", "site")
      trTestSite
        .selectAll("td")
        .data((d, i) => onlyShownForTestSite(d))
        .enter()
        .append("td")
        .attr("class", d => d.class)
        .html(d => d.html)
    },

    updateClinicalTrialsTable: function() {
      let profile = d3.select(".county-profile")

      let criteriaInfo = [
        {
          toggleSelector: ".mustBeCovidPositive",
          filter: site => site["COVID-positive"] === "Yes",
        },
        {
          toggleSelector: ".hasCompensation",
          filter: site => site["Compensation (USD)"] && site["Compensation (USD)"] != "Unavailable",
        },
      ]
      // let criteriaInfo = [
      //   {
      //     toggleSelector: ".prescriptionRequired",
      //     filter: site => site["Referral Required"] === "No",
      //   },
      //   {
      //     toggleSelector: ".needAppointment",
      //     filter: site => site["Appointment Only"] === "No",
      //   },
      //   {
      //     toggleSelector: ".antibodyTest",
      //     filter: site => site["antibodyTest"] === "Yes",
      //   }
      // ]

      // Filter by criteria
      let criteriaFilters = criteriaInfo.filter(info =>
        $(info.toggleSelector).hasClass("selected")
      )
      let sites = mainData.countyTrialSites
      criteriaFilters.forEach(info => {
        sites = sites.filter(s => info.filter(s))
      })

      // let shownTestSiteColumns = [
      //   {
      //     label: "Name",
      //     name: "Name",
      //     html: d =>
      //       `<i class="test-site-icon material-icons">lens</i>&nbsp;&nbsp;<span class='site-name'>${d["Name of Facility"]}</span>`
      //   },
      //   {
      //     class: "toggle-header",
      //     label:
      //       "<i class='material-icons criteria-toggle-header' data-criteria-toggle='prescriptionRequired'>list_alt</i>",
      //     name: "Referral Required"
      //   },
      //   {
      //     class: "toggle-header",
      //     label:
      //       "<i class='material-icons criteria-toggle-header' data-criteria-toggle='needAppointment'>event_available</i>",
      //     name: "Appointment Only"
      //   },
      //   {
      //     class: "toggle-header",
      //     label:
      //       "<i class='material-icons criteria-toggle-header' data-criteria-toggle='antibodyTest'>science</i>",
      //     name: "antibodyTest"
      //   },
      //   { label: "Contact", name: "Phone" }
      // ]
      // let onlyShownForTestSite = d => {
      //   let values = _.map(shownTestSiteColumns, col => ({
      //     html: col.html ? col.html(d) : d[col.name],
      //     class: col.class
      //   }))
      //   return values
      // }
      
      let shownTrialSiteColumns = [
        {
          label: "Name",
          name: "Trial Name",
          html: d =>
            `<i class="trial-site-icon material-icons">lens</i>&nbsp;&nbsp;<span class='site-name'>${d["Trial Name"]}</span>`
        },
        { label: "City", name: "City" },
        {
          class: "toggle-header",
          label:
            "<i class='material-icons criteria-toggle-header' data-criteria-toggle='mustBeCovidPositive'>coronavirus</i>",
          name: "COVID-positive"
        },
        {
          class: "toggle-header",
          label:
            "<i class='material-icons criteria-toggle-header' data-criteria-toggle='hasCompensation'>attach_money</i>",
          name: "Compensation (USD)"
        },
      ]
      let onlyShownForTrialSite = d => {
        let shown = {}
        shownTrialSiteColumns.forEach(
          col => (shown[col.name] = col.html ? col.html(d) : d[col.name])
        )
        return shown
      }

      // profile
      //   .select("#testSitesTable")
      //   .selectAll("tr")
      //   .remove()
      // profile
      //   .select("#testSitesTable")
      //   .append("tr")
      //   .attr("class", "header")
      //   .selectAll("th")
      //   .data(shownTestSiteColumns)
      //   .enter()
      //   .append("th")
      //   .attr("class", d => d.class)
      //   .html(d => d.label)
      // let trTestSite = profile
      //   .select("#testSitesTable")
      //   .selectAll("tr.site")
      //   .data(sites)
      //   .enter()
      //   .append("tr")
      //   .on("click", d => {
      //     this.profilePanel = 2
      //     setTimeout(() => this.displayTestSiteProfile(d))
      //   })
      // trTestSite.attr("class", "site")
      // trTestSite
      //   .selectAll("td")
      //   .data((d, i) => onlyShownForTestSite(d))
      //   .enter()
      //   .append("td")
      //   .attr("class", d => d.class)
      //   .html(d => d.html)

      profile
        .select("#trialSitesTable")
        .selectAll("tr")
        .remove()
      profile
        .select("#trialSitesTable")
        .append("tr")
        .attr("class", "header")
        .selectAll("th")
        .data(shownTrialSiteColumns)
        .enter()
        .append("th")
        .html(d => d.label)
      let trTrialSite = profile
        .select("#trialSitesTable")
        .selectAll("tr.site")
        .data(sites)
        .enter()
        .append("tr")
      .on("click", d => {
        this.profilePanel = 3
        setTimeout(() => this.displayTrialSiteProfile(d))
      })

      trTrialSite.attr("class", "site")
      trTrialSite
        .selectAll("td")
        .data((d, i) => Object.values(onlyShownForTrialSite(d)))
        .enter()
        .append("td")
        .html(d => d)
    },

    displayTestSiteProfile: function(testSite) {
      let profile = d3
        .select(".test-site-profile .site-info")
        .html(testSiteProfileHtml(testSite))

      // Display
      this.profile.showTestSites = true
      this.profile.showClinicalTrials = false
      // d3.select(".test-site-profile").style("display", "block")
      // d3.select(".trial-site-profile").style("display", "none")

      // Collapse
      // $(".accordion #collapseTestSite").collapse("show")
    },

    displayTrialSiteProfile: function(trialSite) {
      let profile = d3
        .select(".trial-site-profile .site-info")
        .html(clinicalProfileHtml(trialSite))

      // Display
      this.profile.showTestSites = false
      this.profile.showClinicalTrials = true
      // d3.select(".test-site-profile").style("display", "none")
      // d3.select(".trial-site-profile").style("display", "block")

      // Collapse
      // $(".accordion #collapseTrialSite").collapse("show")
    },

    fullReset() {
      testSitesShown = false
      clinicalTrialsShown = false
      this.toggleTestSites()
      this.toggleClinicalTrials()
      this.reset()

      this.level = "county"
      this.mode = "total"
      this.relativeToState = true

      d3.select("#resetBtn").style("display", "none")
      this.showHint = true
    },

    reset() {
      this.currentCountyId = null
      this.currentStateName = null
      this.search = ""

      d3.select("#zoomOutBtn").style("display", "none")
      d3.select("#legendTitle").text(`Africa`)


      d3.select("#legendTestSites").select("text").text(`Test Sites`)
      d3.select("#legendClinicalTrials").select("text").text(`Clinical Trials`)

      const legend = d3
        .select("#legend")
        .transition()
        .duration(750)
        .attr("transform", "translate(723,333)scale(0.8)")
      d3.select("#legend #frame")
        .transition()
        .duration(750)
        .attr("height", 200)
      d3.select("#legend #reopening").style("display", "none")

      this.setBreadcrumb("map")
      let svg = d3.select("g#country")

      // active.classed("active", false)
      // active = d3.select(null)

      // svg.transition()
      //     .delay(100)
      //     .duration(750)
      //     .style("stroke-width", "1.5px")
      //     .attr('transform', 'translate('+0+','+0+')')
      // move("g#country", 0, 0, 1, 750)

      const mainSvg = d3.select(".map-frame svg")
      let width = viewBox.width
      let height = viewBox.height
      mainSvg
        .transition()
        .duration(750)
        .call(
          zoom.transform,
          d3.zoomIdentity,
          d3.zoomTransform(mainSvg.node()).invert([width / 2, height / 2])
        )
      // resize dots
      d3.selectAll("g#testSites circle")
        .transition()
        .delay(100)
        .duration(750)
        .attr("r", `1.5px`)

      d3.selectAll("g#clinicalTrials circle")
        .transition()
        .delay(100)
        .duration(750)
        .attr("r", `1.5px`)

      // avoid choosing county
      d3.selectAll("g#states path").attr("fill", "#0000")

      // Display
      this.profilePanel = null
      this.profile.showProfile = false
      this.profile.showState = false
      this.profile.showCounty = false
      this.profile.showTestSites = false
      this.profile.showClinicalTrials = false
      // d3.select(".accordion").style("display", "none")
      // d3.select(".state-profile").style("display", "none")
      // d3.select(".county-profile").style("display", "none")
      // d3.select(".test-site-profile").style("display", "none")
      // d3.select(".trial-site-profile").style("display", "none")
    },

    wrap: function(text, width) {
      text.each(function() {
        let text = d3.select(this),
          words = text
            .text()
            .split(/\s+/)
            .reverse(),
          word,
          line = [],
          lineNumber = 0,
          lineHeight = 1.1, // ems
          x = text.attr("x"),
          y = text.attr("y"),
          dy = 1.1,
          tspan = text
            .text(null)
            .append("tspan")
            .attr("x", x)
            .attr("y", y)
            .attr("dy", dy + "em")
        while ((word = words.pop())) {
          line.push(word)
          tspan.text(line.join(" "))
          if (tspan.node().getComputedTextLength() > width) {
            line.pop()
            tspan.text(line.join(" "))
            line = [word]
            tspan = text
              .append("tspan")
              .attr("x", x)
              .attr("y", y)
              .attr("dy", ++lineNumber * lineHeight + dy + "em")
              .text(word)
          }
        }
      })
    },

    color2: (function(d3) {
      const values = [1] // relative to state
      const max = Math.max(0, ...values)
      return d3
        .scaleSqrt()
        .domain([-max, 0, max])
        .range([-1, 0, 1])
        .interpolate((a, b) =>
          a < 0 ? t => d3.interpolateBlues(1 - t) : t => d3.interpolateReds(t)
        )
    })(d3),

    colorCases: (function(d3) {
      return d3
        .scaleSqrt()
        .domain([-1, 0, 1])
        .range([-1, 0, 1])
        .interpolate((a, b) =>
          a < 0 ? t => d3.interpolateBlues(1 - t) : t => d3.interpolateReds(t)
        )
    })(d3),

    colorActiveCases: (function(d3) {
      return d3
        .scaleSqrt()
        .domain([-1, 0, 1])
        .range([-1, 0, 1])
        .interpolate((a, b) =>
          a < 0
            ? t => d3.interpolateBlues(1 - t)
            : t => d3.interpolatePuRd(t)
        )
    })(d3),

    colorDeaths: (function(d3) {
      return d3
        .scaleSqrt()
        .domain([-1, 0, 1])
        .range([-1, 0, 1])
        .interpolate((a, b) =>
          a < 0 ? t => d3.interpolateReds(1 - t) : t => d3.interpolateBlues(t)
        )
    })(d3),

    colorChange: (function(d3) {
      let interpolateDanger = d3.interpolateRgbBasis([
        "rgb(255,255,255)",
        // "rgb(255,255,0)",
        "rgb(255,128,0)",
        "rgb(255,0,0)"
      ])
      return d3
        .scaleLinear()
        .domain([-1, 0, 1])
        .range([-1, 0, 1])
        .interpolate((a, b) =>
          a < 0
            ? t => d3.interpolateGreens(1 - t)
            : // : t => d3.interpolateRgbBasis(["white", "yellow", "red"])(t))
              t => interpolateDanger(t)
        )
    })(d3)
  }
}
</script>

<style lang="scss">
#covid-map-africa {
  // TODO: support scoped

  @-webkit-keyframes uparrow {
    0% {
      -webkit-transform: translateY(0);
      opacity: 0.4;
    }
    100% {
      -webkit-transform: translateY(-0.4em);
      opacity: 0.9;
    }
  }
  @-webkit-keyframes downarrow {
    0% {
      -webkit-transform: translateY(0);
      opacity: 0.4;
    }
    100% {
      -webkit-transform: translateY(0.4em);
      opacity: 0.9;
    }
  }

  .toolbar .v-btn .v-btn__content {
    text-transform: none;
  }

  .container {
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    position: absolute;
    text-align: center;
  }
  // .arrow {
  //   border-color: transparent;
  //   border-style: solid;
  //   border-width: 0 2em;
  //   display: block;
  //   height: 0;
  //   // position: absolute;

  //   margin: 0;
  //   opacity: 0.4;
  //   text-indent: -9999px;
  //   transform-origin: 50% 50%;
  //   width: 0;
  // }
  .up {
    -webkit-animation: uparrow 0.6s infinite alternate ease-in-out;
    border-bottom: 2em solid #00b6f1;
  }
  .down {
    -webkit-animation: downarrow 0.6s infinite alternate ease-in-out;
    border-top: 2em solid #00b6f1;
  }

  #covid-map {
    color: #333;
  }

  // .last-updated {
  //   color: #333;
  //   font-size: 12px;
  //   padding: 0 6px 3px;
  //   text-align: right;
  // }

  .mode-toggle {
    .v-btn {
      width: 70px;
      min-width: 70px !important;
    }
    .v-btn__content {
      white-space: normal;
      width: 100%;
      text-align: center;
      line-height: 1;
    }
  }
  #app button.v-btn.v-btn--contained.theme--dark.v-size--default {
      border-color: white !important;
  }
  .bc li a:after {
    border-top: 30px solid transparent;
    border-bottom: 30px solid transparent;
    border-left: 20px solid hsla(212, 85%, 35%, 1);
    top: 133%;
    left: 97%;
  }
  .bc li a:before {
    border-top: 30px solid transparent;
    border-bottom: 30px solid transparent;
    margin-top: -30px;
    margin-left: 1px;
  }

  html.only-profile .site-toggles,
  html.only-profile .map-frame,
  html.only-profile .controls,
  html.only-profile .bc-wrapper {
    display: none;
  }
  html:not(.only-profile) .combos {
    display: none;
  }
  html {
    font-family: "Roboto", sans-serif;
  }
  #bc-map .material-icons {
    position: absolute;
    font-size: 20px;
    line-height: 25px;
  }
  .map-frame .map-bottom {
    position: absolute;
    bottom: 10px;
    left: 10px;
    z-index: 4;
  }
  .map-frame .zoom-out-btn {
    display: none;
    font-size: 12px;
    border: 1px solid hsl(212, 85%, 45%);
    color: hsl(212, 85%, 45%);
    background: #eeeeff;
    padding: 0px 3px;
    border-radius: 3px;
    text-decoration: none !important;
  }
  .map-frame .zoom-out-btn i {
    vertical-align: middle;
  }
  .map-frame .hint {
    opacity: 0;
    padding-left: 6px;
    color: #f7f7f7;
    margin-top: 2px;
    font-size: 14px;
    vertical-align: bottom;
    display: inline-block;
    line-height: 1.1;
    padding-bottom: 2px;
  }

  .play-btn {
    font-size: 12px;
    /* border: 1px solid hsl(212, 85%, 45%); */
    border: 1px solid #ccccff;
    background: #eeeeff;
    /* border: 1px solid #ccc;
    background: #eee; */
    padding: 2px 9px;
    border-radius: 3px;
    text-decoration: none;
    display: flex;
    cursor: pointer;
  }
  .play-btn .material-icons {
    font-size: 21px;
    color: hsl(212, 85%, 45%);
  }

  .criteria-toggle {
    color: #99c6e0;
  }
  .criteria-toggle:hover {
    font-size: 14px;
    cursor: pointer;
    color: hsl(224, 89%, 51%);
  }
  .criteria-toggle.selected {
    text-decoration: line-through;
    color: #447adc;
  }
  .criteria-toggle.selected.antibodyTest,
  .criteria-toggle.selected.mustBeCovidPositive,
  .criteria-toggle.selected.hasCompensation {
    text-decoration: none;
    color: #447adc;
  }
  .group .criteria-toggle i.material-icons {
    font-size: 14px;
    color: #99c6e0;
  }
  .group .criteria-toggle:hover i.material-icons {
    font-size: 14px;
    color: hsl(224, 89%, 51%);
  }

  .more-info {
    vertical-align: middle;
    max-width: 19px;
    position: relative;
    left: -5px;
    display: inline-block;
  }

  .group .more-info i.material-icons {
    color: #265794;
    font-size: 18px;
  }

  .criteria-toggle.selected i.material-icons {
    color: #447adc;
  }
  .criteria-toggles {
    display: flex;
    width: 100%;
  }
  .criteria-toggles .group {
    flex-grow: 1;
  }
  .criteria-toggle-header {
    cursor: pointer;
    color: hsl(212, 85%, 45%);
  }
  .site-name {
    color: hsl(224, 89%, 51%);
  }
  .header .icon-box {
    display: inline-block;
  }
  .header .icon-box .icon i.material-icons,
  .header .icon-box .icon span {
    font-size: 14px;
    vertical-align: middle;
    color: #6d6d6d;
  }
  .icon-box .icon i,
  .icon-box .icon i.material-icons {
    font-size: 20px;
    color: #999;
  }
  .icon-box .icon span {
    display: inline-block;
    height: 21px;
    vertical-align: text-bottom;
    color: #636363;
  }
  .icon {
    min-width: 100px;
    display: inline-block;
    white-space: nowrap;
    padding: 0 8px;
    text-align: center;
  }
  .box {
    text-align: center;
  }

  .profiles {
    max-width: 980px;
    width: 100%;
    margin: 10px auto 20px auto;
  }
  .accordion {
    border-radius: 4px;
  }
  .accordion .card-body {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .accordion .card,
  .accordion .card-body,
  .accordion .card-header {
    border: none;
  }
  .accordion h2 {
    color: white;
    text-decoration: none;
    font-size: 16px;
    cursor: pointer;
    padding: 8px 12px;
    margin-top: 0;
  }
  .accordion .state-profile .card-header {
    min-height: 35px;
    background: hsla(212, 85%, 45%, 0.8);
  }
  .accordion .county-profile .card-header {
    min-height: 35px;
    background: hsla(212, 85%, 55%, 0.8);
  }
  .accordion .test-site-profile .card-header,
  .accordion .trial-site-profile .card-header {
    min-height: 35px;
    background: hsla(212, 85%, 65%, 0.8);
  }
  .opening-status {
    position: relative;
  }
  .opening-status .date {
    position: absolute;
    top: -40px;
    left: -30px;
    background: #c8d5e0d1;
    border-radius: 3px;
    padding: 4px 8px;
    display: none;
    border: 1px solid #b5b5b5;
    white-space: nowrap;
    max-width: 300px;
  }
  .opening-status:hover .date {
    display: inline-block;
  }
  .opening-status i.green {
    color: #3bd23b;
  }
  .opening-status i.yellow {
    color: #d2c63b;
  }
  .opening-status i.red {
    color: #e03131;
  }
  .hidden-detail {
    color: #777;
    position: relative;
    overflow: hidden;
    display: block;
    height: 20px;
  }
  .hidden-detail:hover {
    overflow: visible;
  }
  .hidden-detail > span {
    position: absolute;
    padding: 0px 8px;
  }
  .hidden-detail > span i {
    font-size: 12px;
    vertical-align: middle;
  }
  .hidden-detail:hover > span {
    background: #ffffff;
    z-index: 1;
    color: #333;
  }
  .record td:first-child {
    min-width: 140px;
  }
  .record td + td + td {
    width: 100%;
  }

  .test-site-icon {
    color: #89c0d7;
    font-size: 10px;
  }
  .cases-icon {
    background: #888;
    width: 10px;
    height: 10px;
    display: inline-block;
  }
  .trial-site-icon {
    // color: #da87da;
    color: #73d473;
    font-size: 10px;
  }
  .site-toggles {
    max-width: 980px;
    margin: 0 auto;
    padding: 0;
    text-align: right;
    display: flex;
    position: relative;
  }
  .bc-wrapper {
    max-width: 980px;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
  }
  #bc-map .material-icons {
    position: absolute;
    font-size: 19px;
  }
  .controls {
    max-width: 980px;
    width: 100%;
    margin: 0 auto 7px auto;
    background: #0042715e;
    // background: #00427138;
    border: none;
    border-radius: 0 0 3px 3px;
    color: white;
    position: relative;
  }
  .map-frame-wrapper {
    max-width: 980px;
    margin: 0 auto;
    width: 100%;
    position: relative;
  }

  .map-frame-wrapper .loading-map {
    color: white;
    width: 100%;
    position: absolute;
    top: 0;
    text-align: center;
    transform: translateY(-50%);
    top: 50%;
    // animation: blink 1s step-start 0s infinite;
  }
  .map-frame-wrapper .loading-map .flashing {
    animation: blink 2s ease-in-out infinite;
    // animation: blink 1s step-start 0s infinite;
  }
  @keyframes blink {
    0% { opacity: 1; }
    70% { opacity: 0; }
    100% { opacity: 1; }
  }
  .map-frame {
    padding-bottom: 60%;
    background: #104f829e;
    // background: #00427138;
    position: relative;
    width: 100%;
    overflow: hidden;
    border: 1px solid #cecece00;
    border-radius: 0;
  }
  // .map-frame .zoom-out-btn {
  //   position: absolute;
  //   bottom: 10px;
  //   left: 10px;
  //   display: none;
  //   z-index: 10;

  //   font-size: 12px;
  //   border: 1px solid hsl(212, 85%, 45%);
  //   color: hsl(212, 85%, 45%);
  //   background: #eeeeff;
  //   padding: 0px 3px;
  //   border-radius: 3px;
  //   text-decoration: none !important;
  // }
  .map-frame svg {
    position: absolute;
    width: 1000px;
    height: 1000px;
  }
  .play-btn {
    font-size: 12px;
    /* border: 1px solid hsl(212, 85%, 45%); */
    border: none;
    background: #00000010;
    /* border: 1px solid #ccc;
    background: #eee; */
    padding: 2px 9px;
    border-radius: 3px;
    text-decoration: none;
    display: flex;
    cursor: pointer;
  }
  .play-btn .material-icons {
    font-size: 21px;
    color: hsl(212, 85%, 45%);
  }
  .play-btn:hover {
    color: white !important;
  }

  #reopeningStatusChart {
    overflow: hidden;
  }

  div.tooltip {
    position: absolute;
    width: 250px;
    padding: 10px;
    font: 12px sans-serif;
    background: white;
    border: 1px solid #3ab1ff;
    border-radius: 3px;
    pointer-events: none;
    z-index: 4;
  }
  div.tooltip label {
    font-weight: 700;
    margin-top: 7px;
  }

  .siteName {
    font-size: 1.3em;
    display: inline-block;
  }
  .location {
    display: inline-block;
    margin: 3px 0 10px 0;
  }
  .site-details {
    margin-top: 10px;
    width: 100%;
  }
  .site-details td,
  .site-details th {
    padding: 5px;
    text-align: left;
  }
  table.stripped td,
  table.stripped th {
    background: #f6f6f6;
  }
  table.stripped tr:nth-child(even) td,
  table.stripped tr:nth-child(even) th {
    background: none;
  }

  .county-profile h2 {
    margin-bottom: 0;
  }
  .county-profile label {
    display: block;
    font-size: 0.85em;
  }
  .sites-table {
    font-size: 13px;
    width: 100%;
    margin: 15px 0;
  }
  .sites-table td,
  .sites-table th {
    padding: 5px;
    text-align: left;
  }
  .sites-table .site {
    cursor: pointer;
  }
  .sites-table .site:hover td {
    background: #e8e8e8;
  }

  .ranges {
    position: relative;
    display: flex;
    padding: 0 5px 0 2px;
  }
  .ranges #myRange-top {
    position: absolute;
    opacity: 0;
  }
  .controls {
    display: flex;
  }
  .ranges {
    flex: 1 auto;
  }
  #date {
    font-size: 14px;
    padding: 2px 5px 2px 5px;
    width: 90px;
    display: block;
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    color: #fff;
  }
  .slider {
    width: 100%;
    cursor: pointer;
  }

  .bc {
    margin: 0;
    list-style: none;
    overflow: hidden;
    // font: 16px;
    padding: 0 !important;
    min-width: 900px;
  }
  .bc li {
    float: left;
  }
  .bc li a {
    color: white;
    text-decoration: none;
    padding: 8px 0 8px 55px;
    background: brown; /* fallback color */
    background: hsla(212, 85%, 35%, 1);
    position: relative;
    display: block;
    float: left;
  }
  .bc li a:after {
    content: " ";
    display: block;
    width: 0;
    height: 0;
    border-top: 50px solid transparent; /* Go big on the size, and let overflow hide */
    border-bottom: 50px solid transparent;
    border-left: 30px solid hsla(212, 85%, 35%, 1);
    position: absolute;
    top: 50%;
    margin-top: -50px;
    left: 100%;
    z-index: 2;
  }
  .bc li a:before {
    content: " ";
    display: block;
    width: 0;
    height: 0;
    border-top: 50px solid transparent; /* Go big on the size, and let overflow hide */
    border-bottom: 50px solid transparent;
    position: absolute;
    top: 50%;
    margin-top: -50px;
    margin-left: 1px;
    left: 100%;
    z-index: 1;
  }
  .bc li:first-child a {
    padding-left: 14px;
  }
  .bc li:nth-child(2) a {
    background: hsla(212, 85%, 45%, 1);
  }
  .bc li:nth-child(2) a:after {
    border-left-color: hsla(212, 85%, 45%, 1);
  }
  .bc li:nth-child(3) a {
    background: hsla(212, 85%, 55%, 1);
  }
  .bc li:nth-child(3) a:after {
    border-left-color: hsla(212, 85%, 55%, 1);
  }
  .bc li:nth-child(4) a {
    background: hsla(212, 85%, 65%, 1);
  }
  .bc li:nth-child(4) a:after {
    border-left-color: hsla(212, 85%, 65%, 1);
  }
  .bc li:nth-child(5) a {
    background: hsla(212, 85%, 75%, 1);
  }
  .bc li:nth-child(5) a:after {
    border-left-color: hsla(212, 85%, 75%, 1);
  }
  .bc li:last-child a {
    background: transparent !important;
    color: black;
    pointer-events: none;
    cursor: default;
  }
  .bc li:last-child a:after {
    border: 0;
  }
  .bc li a:hover {
    background: hsla(212, 85%, 25%, 1);
  }
  .bc li a:hover:after {
    border-left-color: hsla(212, 85%, 25%, 1) !important;
  }

  .reset-btn {
    font-size: 16px;
    text-decoration: none !important;
    display: none;
    background: #0a478e;
    color: white !important;
    padding: 8px 10px;
    border-radius: 0 0 0 0;
    white-space: nowrap;
  }
  .reset-btn:hover {
    background: #04366e;
  }
  .spacer {
    flex: 1 auto;
  }
  .toggle {
    margin-left: 3px;
    font-size: 12px;
    border: 1px solid #ccc;
    background: #eee;
    padding: 3px 7px;
    border-radius: 3px;
    text-decoration: none;
    color: #222;
    display: inline-block;
  }
  .toggle.on {
    background: #ccc;
  }

  h5.banner {
    background: #e8f3ff;
    padding: 4px 10px;
    margin: 0 -24px;
  }
  .banner.test-sites-banner {
    background: #7dbbd499;
    margin-bottom: 7px;
  }
  .banner.clinical-trials-banner {
    background: #73d47399;
    // background: #da87da99;
    margin-bottom: 7px;
  }

  #reopeningStatusChartWrapper {
    max-width: 850px;
    margin: 0 auto;
    width: 100%;
  }
  #reopeningStatusChart {
    padding-bottom: 35%;
    width: 100%;
  }
  #reopeningStatusChart > svg {
    position: absolute;
  }

  #stateCasesChartWrapper {
    max-width: 850px;
    margin: 0 auto;
    width: 100%;
  }
  #stateCasesChart {
    padding-bottom: 24%;
    width: 100%;
  }
  #stateCasesChart > svg {
    position: absolute;
  }

  #countyCasesChartWrapper {
    max-width: 850px;
    margin: 0 auto;
    width: 100%;
  }
  #countyCasesChart {
    padding-bottom: 24%;
    width: 100%;
  }
  #countyCasesChart > svg {
    position: absolute;
  }

  #stateCasesChart,
  #countyCasesChart {
    overflow: hidden;
  }

  // #reopeningStatusChart .x.axis .tick,
  #stateCasesChart .tick,
  #countyCasesChart .tick {
    visibility: hidden;
  }
  #reopeningStatusChart .x.axis .tick:nth-child(9n + 3) {
    visibility: visible;
  }
  #stateCasesChart .tick:nth-child(9n + 2),
  #countyCasesChart .tick:nth-child(9n + 2) {
    visibility: visible;
  }

  #stateCasesChart,
  #countyCasesChart {
    position: relative;
  }
  #reopeningStatusChart {
    position: relative;
  }
  .tooltip-label {
    position: absolute;
    min-width: 70px;
    padding: 4px;
    font: 10px sans-serif;
    background: white;
    border: 1px solid #3ab1ff;
    border-radius: 3px;
    pointer-events: none;
    line-height: 14px;
    z-index: 4;
  }

  .h1,h1{font-size:2.5rem}
  .h2,h2{font-size:2rem}
  .h3,h3{font-size:1.75rem}
  .h4,h4{font-size:1.5rem}
  .h5,h5{font-size:1.25rem}
  .h6,h6{font-size:1rem}

  .icon .material-icons {
    margin-right: 3px;
  }

  .group {
    font-size: 14px;
    padding-bottom: 8px;
  }
  .group h5 {
    background: #eaeaea;
    padding: 7px 12px;
    margin: 12px -24px 8px;
    font-size: 17px;
    line-height: 1;
  }
  .group h6 {
    padding: 0px 12px;
    margin: 0;
    display: inline-block;
  }
  .group label {
    font-weight: 700;
    margin-bottom: 4px;
  }
  .group .main {
    padding: 8px 0 4px;
    margin: 0 0 0 20px;
    min-height: 45px;
  }
  .group .box {
    border: 1px solid #bfe3ff;
    padding: 8px 16px 4px;
    border-radius: 3px;
    margin: 0 20px;
    font-size: 12px;
    background: #e2eef3;
  }
  .group .prohibited {
    border: 1px solid #e2e2cc;
    padding: 8px 16px 4px;
    border-radius: 3px;
    margin: 0 20px;
    font-size: 12px;
    background: #f3f3e2;
  }
  .group .prohibited .header {
    margin: 2px 0 12px 0;
    text-align: center;
    width: 100%;
    font-size: 1.2em;
    display: block;
  }

  .group table.requirements th,
  .group table.requirements td {
    padding: 4px 8px;
  }

  .group table.requirements label {
    margin: 0;
  }

  .group table.requirements {
    text-align: center;
    font-size: 14px;
    margin: 5px auto 11px auto;
  }

  .group table.requirements tr:first-child {
    background: #f5f5f5;
  }
  .group table.requirements tr {
    border-bottom: 1px solid #e3e3e3;
  }

  .group table.requirements th:first-child {
    min-width: 250px;
  }

  .group .source {
    float: right;
    padding: 0;
    font-size: 10px;
    margin-top: 10px;
    margin-right: -11px;
    text-align: right;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 300px;
  }
  .group .closed .material-icons {
    color: #e20000;
  }
  .group .open .material-icons {
    color: #329c00;
  }
  .group i.material-icons {
    font-size: 12px;
    color: #b3b3b3;
  }
  .group .main .openClose {
    padding-left: 12px;
    width: 46%;
    display: inline-block;
  }
  .summary {
    padding: 10px 8px;
    margin: 10px 0;
    font-size: 0.9em;
    border: 1px solid #dadada;
    border-radius: 3px;
    background: whitesmoke;
  }

  #field-executiveSummary {
    white-space: pre-wrap;
  }

  .toggle-header {
    text-align: center;
    width: 1px;
  }
  .text-center {
    text-align: center;
  }
  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }

  .highlight-prohibited,
  .highlight-not-permitted,
  .highlight-required,
  .highlight-yes {
    color: #e20000;
  }
  .highlight-not-required,
  .highlight-permitted,
  .highlight-no {
    color: #03009c;
  }
  .highlight-recommended {
    color: #70009c;
  }

  .requirements th .icon-box {
    font-weight: normal;
  }

  .search {
    width: 300px;
    input {
      min-width: 1px !important;
    }
    .v-input__slot, .v-input__control {
      min-height: 28px !important;
    }
    .v-select__slot label {
      top: 4px!important;
    }
  }


  @media only screen and (max-width: 600px) {
    .map-frame-wrapper .loading-map {
      font-size: 0.7em;
    }
    .mode-toggle {
      .v-btn {
        width: initial;
      }
      .v-btn__content {
        white-space: nowrap;
      }
    }
    .group .main {
      margin: 0 -14px;
    }

    .group table.requirements th:first-child {
      min-width: 150px;
      width: 150px;
    }

    .group .source {
      max-width: 150px;
    }

    .map-frame .hint {
      font-size: 10px;
    }
    .map-frame .info-source {
      max-width: 221px;
    }

    .criteria-toggles .group {
      width: 100%;
      padding-bottom: 2px;
    }
  }
}
</style>
